import { useEffect, useState, useRef } from "react";
import {
  Button,
  ButtonGroup,
  Col,
  Form,
  FormControl,
  Row,
  Modal,
  Tab,
  Nav,
  Card,
  InputGroup,
} from "react-bootstrap";
import "./admin.css";
import moment from "moment";
import { Back, Folder, House } from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import {
  ChangedRoleAccessScreenAction,
  ChangedUserRoleAction,
  GetReportingCradicialsAction,
  getUsersListAction,
  AddNewUserAction,
  DeleteUserAction,
  EditUserAction,
  DuplicateUserAction,
  getUserPermissionsAction,
  UploadDomainWhitelistCSVAction,
  UploadAppWhitelistCSVAction,
  getDomainWhiteListCSV,
  getAppWhiteListCSV,
  deleteWhitelistAction,
  removeUserTokenAction,
  getAdvertiser,
  getS3FilesAndFoldersAction,
} from "../../Redux/Actions/AdminActions";
// import { getAdvertiser } from "../../Redux/Actions/CCreativeUploadActions";
import { IReduxState } from "../../utils/types";
import { useFormik } from "formik";
import axios from "../../axiosConfig";
import { GetRoleListAction } from "../../Redux/Actions/RoleAction";
import { GetDomainListAction } from "../../Redux/Actions/DomainAction";
import * as yup from "yup";
import { ToastAction } from "../../Redux/Actions/ToastAction";
import { useNavigate } from "react-router-dom";
import { browsers_list, counties_list, os_list } from "./AdminConstant";
import LoggerTab from "./AdminTabs/LoggerTab";
import AccountMgmtTab from "./AdminTabs/AccountMgmtTab";
import RolesTab from "./AdminTabs/RolesTab";
import ReportingTab from "./AdminTabs/ReportingTab";
import FeatherIcon from "feather-icons-react";
import { components } from 'react-select';
import { Lock } from 'feather-icons-react';

const AdminPage = () => {
  const [currentScreen, setCurrentScreen] = useState<String>("Logger");
  const [usersList, setUsersList] = useState<any>([]);
  const [invalidFields, setInvalidFields] = useState<string[]>([]);
  // const [newUserEmail, setNewUserEmail] = useState<any>('')

  const [showValidationModal, setShowValidationModal] = useState(false);
  const [validationErrors, setValidationErrors] = useState<string[]>([]);

  const [usersSaveDisabled, setUsersSaveDisabled] = useState<any>(true);
  const [isPopUp, setIsPopUp] = useState<any>(false);
  const [rolesList, setRolesList] = useState<Array<any>>([]);
  const [optionSelected, setOptionSelected] = useState<any>({});
  const [userOptionSelected, setUserOptionSelected] = useState<any>({});
  const [roleAccessPage, setRoleAccessPage] = useState<any>([]);
  const [userAccessRole, setUserAccessRole] = useState<any>([]);
  //const [cTargetingID, setCtargetingID] = useState<any>([]);
  const [cTargetingIpAddressValue, setCTargetingIpAddressValue] = useState<any>(
    []
  );
  const [cTargetingMobileIpAddressValue, setCTargetingMobileIpAddressValue] =
    useState<any>([]);
  const [cTargetingIpNoId, setCTargetingIpNoId] = useState<any>([]);
  const [cTargetingCCreativeValue, setCTargetingCCreativeValue] = useState<any>(
    []
  );
  const [ctargetingUserIDs, setCtargetingUserIDs] = useState<any>([]);
  const [cTargetingMultiUid, setCtargetingMultiUid] = useState<any>([]);
  const [cTargetingMultiNoId, setCtargetingMultiNoId] = useState<any>([]);

  const [cTargetingIPMyDSP, setCTargetingIPMyDSP] = useState("");
  const [cTargetingWebMyDSP, setCTargetingWebMyDSP] = useState("");
  const [cTargetingIDFA, setCTargetingIDFA] = useState("");
  const [cTargetingGAID, setCTargetingGAID] = useState("");

  const [showErrorModal, setShowErrorModal] = useState(false);
  const [cJscId, setCJscId] = useState<any>([]);
  const [cloggerClearEvents, setCloggerClearEvents] = useState<any>([]);

  const [cJscURLWhiteList, setCJscURLWhiteList] = useState("");
  const [cjscLimit, setCjscLimit] = useState(false);
  const [wlblProxy, setWLBLProxy] = useState(false);
  const [truncatedIPs, setTruncatedIPs] = useState(false);
  const [multiCampaign, setMultiCampaign] = useState(false);
  const [cooldown,setCooldown] = useState(false);
  const [allowPause, setAllowPause] = useState(false);
  const [allowEdit, setAllowEdit] = useState(false);
  const [augmentor, setAugmentor] = useState(false);
  const [augmentorOpSec, setAugmentorOpSec] = useState(false);
  const [opSecType, setOpSecType] = useState(false);
  const [bidOpSec, setBidOpSec] = useState(false);
  const [mandatory, setMandatory] = useState(false);
  const [byAuctionId, setByAuctionId] = useState(false);
  const [byBidTime, setByBidTime] = useState(false);
  const [bidOpSecTime, setBidOpSecTime] = useState(30);
  const [bidOpSecOffset, setBidOpSecOffset] = useState(10);

  const [prefilter, setPrefilter] = useState(false);
  const [prefilterIP, setPrefilterIP] = useState("");
  const [prefilterIPErr, setPrefilterIPErr] = useState(false);
  const [destPort, setDestPort] = useState("");
  const [autoIp, setAutoIp] = useState(false);
  const [ignoreUserProxy, setIgnoreUserProxy] = useState(false);
  const [showFilterErrors, setShowFilterErrors] = useState(false);
  const [ignoreHttp, setIgnoreHttp] = useState(false);
  const [showCjscIgnoreHttp, setShowCjscIgnoreHttp] = useState(false);
  const [adUrlType, setAdUrlType] = useState(false);
  const [userType, setUserType] = useState(false);
  const [requireVPN, setRequireVPN] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showSecret, setShowSecret] = useState(false);
  const [clientID, setClientID] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [controliumType, setControliumType] = useState(false);
  const [showHash, setShowHash] = useState(true);
  const [logConn, setLogConn] = useState(false);
  const [maxCampPerDay, setMaxCampPerDay] = useState(0);
  const [opSecBidTimer, setOpSecBidTimer] = useState(30);
  const [cooldownTime,setCooldownTime] = useState(1);
  const [maxCampPerMonth, setMaxCampPerMonth] = useState(0);
  const [cJscIdDropdownList, setCJscIdDropdownList] = useState<any>([]);
  const [cJscCallbackURL, setCJscCallbackURL] = useState("");
  const [cJscCallbackError, setCJscCallbackError] = useState(false);
  const [cLineItem, setCLineItem] = useState("");
  const [cLineItemWithoutUserID, setCLineItemWithoutUserID] = useState("");
  const [cLineItemMyDSP, setCLineItemMyDSP] = useState("");
  const [cLineItemWithoutUserIDMyDSP, setCLineItemWithoutUserIDMyDSP] =
    useState("");
  const [cLineItemDemo, setCLineItemDemo] = useState("");
  const [cLineItemDemoWithoutUserID, setCLineItemDemoWithoutUserID] =
    useState("");
  const [cLineItemDemoMyDSP, setCLineItemDemoMyDSP] = useState("");
  const [cLineItemDemoWithoutUserIDMyDSP, setCLineItemDemoWithoutUserIDMyDSP] =
    useState("");
  const [cLogger, setCLogger] = useState("");
  const [gluName, setGluName] = useState("");
  const [beeswaxCID, setBeeswaxCID] = useState("");
  const [dashMonthlyBudget, setDashMonthlyBudget] = useState("");
  const [tenantName, setTenantName] = useState("");
  const [logoFolder, setLogoFolder] = useState("");

  //const [userIPRestriction, setUserIPRestriction] = useState("");
  const [userIPRestrictionFrom, setUserIPRestrictionFrom] = useState("");
  const [userIPRestrictionFromErr, setUserIPRestrictionFromErr] =
    useState(false);
  const [userIPRestrictionTo, setUserIPRestrictionTo] = useState("");
  const [userIPRestrictionToErr, setUserIPRestrictionToErr] = useState(false);
  const [gluNameError, setGluNameError] = useState(false);
  const [showRemoveTokenModal, setShowRemoveTokenModal] = useState(false);

  /*------START:BASED ON ROLE ACCESS SELECTION-------*/
  const [isValidateCJSCIds, setIsValidateCJSCIds] = useState(false);
  const [isValidateCTargeting, setIsValidateCTargeting] = useState(false);
  const [isValidateProdClineItem, setIsValidateProdClineItem] = useState(false);
  const [isValidateDemoClineItem, setIsValidateDemoClineItem] = useState(false);
  const [isValidateCLogger, setIsValidateCLogger] = useState(false);
  const [isValidateGluName, setIsValidateGluName] = useState(false);
  /*------END:BASED ON ROLE ACCESS SELECTION-------*/

  const [showDeleteWhiteList, setShowDeleteWhiteList] = useState(false);
  const [deleteWhiteListType, setDeleteWhiteListType] = useState("");

  const [cjscCallbackType, setCjscCallbackType] = useState("off");

  const [state, setState] = useState({
    startDate: moment().subtract(1, "days").startOf("day"),
    endDate: moment().subtract(1, "days").endOf("day"),
  });
  const [visibleEditUser, setVisibleEditUser] = useState(false);
  const [visibleDuplicateUser, setVisibleDuplicateUser] = useState(false);
  const [listCountries, setListCountries] = useState<any>([]);
  const [countriesType, setCountriesType] = useState<any>("wl");
  // const [blackListCountries, setBlackListCountries] = useState<any>([]);
  const [listBrowsers, setListBrowsers] = useState<any>([]);
  const [browsersType, setBrowsersType] = useState<any>("wl");
  // const [blackListBrowsers, setBlackListBrowsers] = useState<any>([]);
  const [listOs, setListOs] = useState<any>([]);
  const [ossType, setOSsType] = useState<any>("wl");
  // const [blackListOs, setBlackListOs] = useState<any>([]);

  const { startDate, endDate } = state;
  const dispatch = useDispatch();
  const authState = useSelector((state: IReduxState) => state.Auth);
  const adminState = useSelector((state: IReduxState) => state.Admin);
  const rolesState = useSelector((state: IReduxState) => state.Roles);
  const domainWhitelistUploadRef = useRef<HTMLInputElement>(null);
  const domainAppUploadRef = useRef<HTMLInputElement>(null);

  //c-upload
  // const [cup_dsp, setCup_dsp] = useState("beeswax");
  const [ccreative_folder, setCcreative_folder] = useState("");
  const [cc_lineItems, setCc_lineItems] = useState("");
  const [cc_dsp, setCc_dsp] = useState<any>([]);
  const [cc_adv, setCc_adv] = useState<any>([]);
  const [cc_os, setCc_os] = useState<any>([]);
  const [cc_noas, setCc_noas] = useState<any>([]);
  const [cc_cookie, setCc_cookie] = useState<any>([]);
  const [cc_ua, setCc_ua] = useState<any>([]);
  const [cc_timer, setCc_timer] = useState<any>([]);
  const [cc_infinite_fifo, setCc_infinite_fifo] = useState<any>([]);
  const [cc_ipV6,setCc_ipV6] = useState<any>([]);
  const [createSubFolderPopup, setCreateSubFolderPopup] = useState(false);
  const [checkFolder, setCheckFolder] = useState(false);
  const [validFolder, setValidFolder] = useState(false);
  const [folderName, setFolderName] = useState("");
  const [cur_folder, setCur_folder] = useState(ccreative_folder);
  const [advertiserOptions, setAdvertiserOptions] = useState<
    { value: string; label: string }[]
  >([]);

  useEffect(() => {
    dispatch(getAdvertiser());
  }, [dispatch]);

  useEffect(() => {
    setAdvertiserOptions([
      ...adminState.adv.map((adv: any) => ({
        value: adv.advId,
        label: adv.advName,
      })),
    ]);
  }, [adminState.adv]);

  const createSubFolderForm = useFormik({
    initialValues: {
      folder_name: "",
    },
    validationSchema: yup.object().shape({
      folder_name: yup.string().required("*"),
    }),
    onSubmit: (values, { resetForm }) => {
      //console.log(values);
    },
  });

  const [showS3Browser, setShowS3Browser] = useState(false);

  const handleChooseThisFolder = () => {
    setCcreative_folder(cur_folder);
    setShowS3Browser(false);
  };

  const isCcreativeEnabled = () => {
    let ccreativeId = rolesList.find((x: any) => x.role_name === "creative");
    let exist = userAccessRole.find((x: any) => x === ccreativeId._id);
    return exist ? false : true;
  };

  const handleCheckFolderContent = () => {
    // let pathCheck: any = [];
    // if (ccreative_folder) {
    //   pathCheck = ccreative_folder.split("/");
    // }

    dispatch(
      getS3FilesAndFoldersAction(
        ccreative_folder ? ccreative_folder : ""
        // : folderName ? pathCheck && pathCheck.length>0 && pathCheck[0]!==folderName? pathCheck[0] :folderName :''
      )
    );
    setShowS3Browser(true);
    setUsersSaveDisabled(false);
  };

  async function handleCreateSubFolder(): Promise<any> {
    try {
      const response = await axios.get(
        `validateName?folderName=${cur_folder}${folderName}`
      );

      const { status } = response;
      if (status === 200) {
        setCur_folder(cur_folder + folderName + "/");
        dispatch(
          getS3FilesAndFoldersAction(`${ccreative_folder}${folderName}/`)
        );
        setValidFolder(true);
        setCheckFolder(true);
        setCreateSubFolderPopup(false);
      }
    } catch (error: any) {
      setCheckFolder(true);
      setValidFolder(false);
    }
  }

  const handleFolderClick = (folderNames: any) => {
    setCur_folder(folderNames);
    dispatch(getS3FilesAndFoldersAction(folderNames));
  };

  const handleFolderBack = (folderNames: String) => {
    var subs = folderNames.split("/");
    if (subs.length > 2) {
      setCur_folder(
        folderNames.substring(0, folderNames.indexOf(subs[subs.length - 2]))
      );
      dispatch(
        getS3FilesAndFoldersAction(
          folderNames.substring(0, folderNames.indexOf(subs[subs.length - 2]))
        )
      );
    } else {
      dispatch(
        getS3FilesAndFoldersAction(
          ccreative_folder
            ? subs[0] !== ccreative_folder
              ? subs[0]
              : ccreative_folder
            : ""
        )
      );
    }
  };

  const navigate = useNavigate();

  const auto_clear_events_list = [
    { value: -1, label: "Never" },
    { value: 1, label: "After 1 day" },
    { value: 7, label: "After 7 days" },
  ];

  useEffect(() => {
    if (Object.keys(optionSelected).length !== 0) {
      setRoleAccessPage(optionSelected.access_screen);
    }
  }, [optionSelected]);

  useEffect(() => {
    // accoun
    dispatch(GetRoleListAction());
    dispatch(GetDomainListAction());
  }, [dispatch]);

  useEffect(() => {
    if (adminState?.userList) {
      const temp: any = [];
      adminState?.userList.map((obj: any) => {
        return temp.push({
          ...obj,
          value: obj.email,
          label: `${obj.name} | ${obj.email}`,
        });
      });
      const cjsc_dropdown_list: any = [];
      adminState?.userList.map((obj: any) => {
        return cjsc_dropdown_list.push({
          ...obj,
          value: obj._id,
          label: `${obj.name} | ${obj.email}`,
        });
      });
      setCJscIdDropdownList(cjsc_dropdown_list);
      setUsersList(temp);
    }
  }, [adminState?.userList]);

  useEffect(() => {
    if (rolesState.roles) {
      const temp: any = [];
      rolesState.roles.map((obj: any) => {
        return temp.push({
          ...obj,
          value: obj.role_name,
          label: obj.role_name,
        });
      });
      setRolesList(temp);
    }
  }, [rolesState.roles]);

  const handleChangeUser = (selected: any) => {
    if (selected.countries && selected.countries.length > 0) {
      let selectedCountries = counties_list.filter((c: any) =>
        selected.countries.includes(c.code)
      );
      if (selectedCountries && selectedCountries.length > 0) {
        const tempSelectedCountries: any = [];
        selectedCountries.map((obj: any) => {
          return tempSelectedCountries.push({
            ...obj,
            value: obj.code,
            label: obj.name,
          });
        });
        setListCountries(tempSelectedCountries);
      } else {
        setListCountries([]);
      }
    } else {
      setListCountries([]);
    }

    if (selected.browsers && selected.browsers.length > 0) {
      let selectedBrowsers = browsers_list.filter((c: any) =>
        selected.browsers.includes(c.name)
      );
      if (selectedBrowsers && selectedBrowsers.length > 0) {
        const tempSelectedBrowsers: any = [];
        selectedBrowsers.map((obj: any) => {
          return tempSelectedBrowsers.push({
            ...obj,
            value: obj.name,
            label: obj.name,
          });
        });
        setListBrowsers(tempSelectedBrowsers);
      } else {
        setListBrowsers([]);
      }
    } else {
      setListBrowsers([]);
    }

    ///////
    if (selected.oss && selected.oss.length > 0) {
      let selectedOss = os_list.filter((c: any) =>
        selected.oss.includes(c.code)
      );
      if (selectedOss && selectedOss.length > 0) {
        const tempSelectedOss: any = [];
        selectedOss.map((obj: any) => {
          return tempSelectedOss.push({
            ...obj,
            value: obj.code,
            label: obj.name,
          });
        });
        setListOs(tempSelectedOss);
      } else {
        setListOs([]);
      }
    } else {
      setListOs([]);
    }

    setUserOptionSelected(selected);
    setUserAccessRole(selected.roles);
    if (selected.cjsc && selected.cjsc.length > 0 && selected.cjsc[0] !== "") {
      let selectedCJSIds: any = [];
      cJscIdDropdownList.map((x: any) => {
        if (selected.cjsc.includes(x.value)) {
          selectedCJSIds.push(x);
        }
        return null;
      });
      setCJscId(selectedCJSIds);
    } else {
      setCJscId([]);
    }

    if (selected?.ctarget_id) {
      setCtargetingUserIDs(selected?.ctarget_id);
    } else {
      setCtargetingUserIDs("");
    }
    if (selected?.ctarget_ip) {
      setCTargetingIpAddressValue(selected?.ctarget_ip);
    } else {
      setCTargetingIpAddressValue("");
    }
    if (selected?.ctarget_mobile_ip) {
      setCTargetingMobileIpAddressValue(selected?.ctarget_mobile_ip);
    } else {
      setCTargetingMobileIpAddressValue("");
    }
    if (selected?.ctarget_ip_no_id) {
      setCTargetingIpNoId(selected?.ctarget_ip_no_id);
    } else {
      setCTargetingIpNoId("");
    }
    if (selected?.ctarget_multi_uid) {
      setCtargetingMultiUid(selected?.ctarget_multi_uid);
    } else {
      setCtargetingMultiUid("");
    }
    if (selected?.ctarget_multi_no_id) {
      setCtargetingMultiNoId(selected?.ctarget_multi_no_id);
    } else {
      setCtargetingMultiNoId("");
    }
    if (selected?.ctarget_ccreative) {
      setCTargetingCCreativeValue(selected?.ctarget_ccreative.join(","));
    } else {
      setCTargetingCCreativeValue([]);
    }
    if (selected?.ctarget_ip_mydsp) {
      setCTargetingIPMyDSP(selected?.ctarget_ip_mydsp);
    } else {
      setCTargetingIPMyDSP("");
    }
    if (selected?.ctarget_web_mydsp) {
      setCTargetingWebMyDSP(selected?.ctarget_web_mydsp);
    } else {
      setCTargetingWebMyDSP("");
    }
    if (selected?.ctarget_idfa_mydsp) {
      setCTargetingIDFA(selected?.ctarget_idfa_mydsp);
    } else {
      setCTargetingIDFA("");
    }
    if (selected?.ctarget_gaid_mydsp) {
      setCTargetingGAID(selected?.ctarget_gaid_mydsp);
    } else {
      setCTargetingGAID("");
    }

    if (selected.line_item_id) {
      setCLineItem(selected.line_item_id);
    } else {
      setCLineItem("");
    }
    if (selected?.line_item_without_id) {
      setCLineItemWithoutUserID(selected.line_item_without_id);
    } else {
      setCLineItemWithoutUserID("");
    }
    if (selected.line_item_id_demo) {
      setCLineItemDemo(selected.line_item_id_demo);
    } else {
      setCLineItemDemo("");
    }
    if (selected?.line_item_without_id_demo) {
      setCLineItemDemoWithoutUserID(selected.line_item_without_id_demo);
    } else {
      setCLineItemDemoWithoutUserID("");
    }
    if (selected.line_item_id_mydsp) {
      setCLineItemMyDSP(selected.line_item_id_mydsp);
    } else {
      setCLineItemMyDSP("");
    }
    if (selected?.line_item_without_id_mydsp) {
      setCLineItemWithoutUserIDMyDSP(selected.line_item_without_id_mydsp);
    } else {
      setCLineItemWithoutUserIDMyDSP("");
    }
    if (selected.line_item_id_demo_mydsp) {
      setCLineItemDemoMyDSP(selected.line_item_id_demo_mydsp);
    } else {
      setCLineItemDemoMyDSP("");
    }
    if (selected?.line_item_without_id_demo_mydsp) {
      setCLineItemDemoWithoutUserIDMyDSP(
        selected.line_item_without_id_demo_mydsp
      );
    } else {
      setCLineItemDemoWithoutUserIDMyDSP("");
    }
    if (selected.cLogger_id) {
      setCLogger(selected.cLogger_id);
    } else {
      setCLogger("");
    }
    if (selected.username) {
      setUsername(selected.username);
    } else {
      setUsername("");
    }
    if (selected.password) {
      setPassword(selected.password);
    } else {
      setPassword("");
    }
    if (selected.client_id) {
      setClientID(selected.client_id);
    } else {
      setClientID("");
    }
    if (selected.client_secret) {
      setClientSecret(selected.client_secret);
    } else {
      setClientSecret("");
    }
    if (selected.tenant_name) {
      setTenantName(selected.tenant_name);
    } else {
      setTenantName("");
    }
    if (selected.logo_folder) {
      setLogoFolder(selected.logo_folder);
    } else {
      setLogoFolder("");
    }

    //ccreative
    if (selected?.cc_adv) {
      let getIndexFun = (el: any) => el.value === selected?.cc_adv;
      let autoIndex = advertiserOptions.findIndex(getIndexFun);
      if (autoIndex > -1) {
        setCc_adv(advertiserOptions[autoIndex]);
      }
    } else {
      setCc_adv("");
    }
    if (selected?.cc_cookie) {
      let getIndexFun = (el: any) =>
        (el.value === selected?.cc_cookie) === true ? "yes" : "no";
      let autoIndex = yesnoOptions.findIndex(getIndexFun);
      if (autoIndex > -1) {
        setCc_cookie(yesnoOptions[autoIndex]);
      }
    } else {
      setCc_cookie(yesnoOptions[0]);
    }

    if (selected?.cc_ua) {
      // setCc_ua(selected.cc_ua);
      let getIndexFun = (el: any) =>
        (el.value === selected?.cc_ua) === true ? "yes" : "no";
      let autoIndex = yesnoOptions.findIndex(getIndexFun);
      if (autoIndex > -1) {
        setCc_ua(yesnoOptions[autoIndex]);
      }
    } else {
      setCc_ua(yesnoOptions[1]);
    }

    if (selected?.cc_timer) {
      // setCc_timer(selected.cc_timer);
      let getIndexFun = (el: any) =>
        (el.value === selected?.cc_timer) === true ? "yes" : "no";
      let autoIndex = yesnoOptions.findIndex(getIndexFun);
      if (autoIndex > -1) {
        setCc_timer(yesnoOptions[autoIndex]);
      }
    } else {
      setCc_timer(yesnoOptions[1]);
    }

    if (selected?.cc_infinite_fifo) {
      let getIndexFun = (el: any) =>
        (el.value === selected?.cc_infinite_fifo) === true ? "yes" : "no";
      let autoIndex = yesnoOptions.findIndex(getIndexFun);
      if (autoIndex > -1) {
        setCc_infinite_fifo(yesnoOptions[autoIndex]);
      }
    } else {
      setCc_infinite_fifo(yesnoOptions[1]);
    }

    if (selected?.cc_ipV6) {
      let getIndexFun = (el: any) =>
        (el.value === selected?.cc_ipV6) === true ? "yes" : "no";
      let autoIndex = yesnoOptions.findIndex(getIndexFun);
      if (autoIndex > -1) {
        setCc_ipV6(yesnoOptions[autoIndex]);
      }
    } else {
      setCc_ipV6(yesnoOptions[1]);
    }

    if (selected?.cc_noas) {
      // setCc_noas(selected.cc_noas);
      let getIndexFun = (el: any) =>
        (el.value === selected?.cc_noas) === true ? "yes" : "no";
      let autoIndex = yesnoOptions.findIndex(getIndexFun);
      if (autoIndex > -1) {
        setCc_noas(yesnoOptions[autoIndex]);
      }
    } else {
      setCc_noas(yesnoOptions[0]);
    }
    if (selected?.cc_folder) {
      setCcreative_folder(selected.cc_folder);
    }

    if (selected?.cc_os) {
      // setCc_os(selected.cc_os);
      let getIndexFun = (el: any) => el.value === selected?.cc_os;
      let autoIndex = OsOptions.findIndex(getIndexFun);
      if (autoIndex > -1) {
        setCc_os(OsOptions[autoIndex]);
      }
    } else {
      setCc_os(OsOptions[2]);
    }

    if (selected?.cc_dsp) {
      // setCc_dsp(selected.cc_dsp);
      let getIndexFun = (el: any) => el.value === selected?.cc_dsp;
      let autoIndex = dspOptions.findIndex(getIndexFun);
      if (autoIndex > -1) {
        setCc_dsp(dspOptions[autoIndex]);
      }
    } else {
      setCc_dsp(dspOptions[0]);
    }

    if (selected?.cc_lineItems) {
      setCc_lineItems(selected.cc_lineItems.join(","));
    } else {
      setCc_lineItems("");
    }
    if (selected?.cc_folder) {
      setCcreative_folder(selected.cc_folder);
    } else {
      setCcreative_folder("");
    }

    if (selected.ip_restrict_from) {
      setUserIPRestrictionFrom(selected.ip_restrict_from);
    } else {
      setUserIPRestrictionFrom("");
    }
    if (selected.ip_restrict_to) {
      setUserIPRestrictionTo(selected.ip_restrict_to);
    } else {
      setUserIPRestrictionTo("");
    }
    if (selected.glu_name) {
      setGluName(selected.glu_name);
    } else {
      setGluName("");
    }
    if (selected.beeswax_cid) {
      setBeeswaxCID(selected.beeswax_cid);
    } else {
      setBeeswaxCID("");
    }
    if (selected.dash_monthly_budget) {
      setDashMonthlyBudget(selected.dash_monthly_budget);
    } else {
      setDashMonthlyBudget("");
    }
    if (selected?.cjsc_ad_url_whitelist) {
      setCJscURLWhiteList(selected.cjsc_ad_url_whitelist);
    } else {
      setCJscURLWhiteList("");
    }
    if (selected?.prefilter_ip) {
      setPrefilterIP(selected.prefilter_ip);
    } else {
      setPrefilterIP("");
    }
    if (selected?.dest_port) {
      setDestPort(selected.dest_port);
    } else {
      setDestPort("");
    }

    if (selected?.max_camp_per_day) {
      setMaxCampPerDay(selected.max_camp_per_day);
    } else {
      setMaxCampPerDay(0);
    }
    if (selected?.max_camp_per_month) {
      setMaxCampPerMonth(selected.max_camp_per_month);
    } else {
      setMaxCampPerMonth(0);
    }
    if (selected?.cjsc_callback_url) {
      setCJscCallbackURL(selected.cjsc_callback_url);
    } else {
      setCJscCallbackURL("");
    }

    if (selected?.cjsc_callback_type) {
      setCjscCallbackType(selected.cjsc_callback_type);
    } else {
      setCjscCallbackType("off");
    }

    if (selected?.cjsc_limit) {
      setCjscLimit(selected.cjsc_limit);
    } else {
      setCjscLimit(selected.cjsc_limit);
    }

    if (selected?.wlbl_proxy) {
      setWLBLProxy(selected.wlbl_proxy);
    } else {
      setWLBLProxy(selected.wlbl_proxy);
    }

    if (selected?.truncated_ips) {
      setTruncatedIPs(selected.truncated_ips);
    } else {
      setTruncatedIPs(selected.truncated_ips);
    }

    if (selected?.multi_campaign) {
      setMultiCampaign(selected.multi_campaign);
    } else {
      setMultiCampaign(selected.multi_campaign);
    }
    if (selected?.cooldown) {
      setCooldown(selected.cooldown);
    } else {
      setCooldown(selected.cooldown);
    }

    if (selected?.allow_pause) {
      setAllowPause(selected.allow_pause);
    } else {
      setAllowPause(selected.allow_pause);
    }

    if (selected?.allow_edit) {
      setAllowEdit(selected.allow_edit);
    } else {
      setAllowEdit(selected.allow_edit);
    }

    if (selected?.augmentor) {
      setAugmentor(selected.augmentor);
    } else {
      setAugmentor(selected.augmentor);
    }

    if (selected?.augmentor_opsec) {
      setAugmentorOpSec(selected.augmentor_opsec);
    } else {
      setAugmentorOpSec(selected.augmentor_opsec);
    }

    if (selected?.opsec_type) {
      setOpSecType(selected.opsec_type);
    } else {
      setOpSecType(selected.opsec_type);
    }

    if (selected?.opsec_bid_timer) {
      setOpSecBidTimer(selected.opsec_bid_timer);
    } else {
      setOpSecBidTimer(selected.opsec_bid_timer);
    }

    if (selected?.bid_opsec) {
      setBidOpSec(selected.bid_opsec);
    } else {
      setBidOpSec(selected.bid_opsec);
    }

    if (selected?.mandatory) {
      setMandatory(selected.mandatory);
    } else {
      setMandatory(selected.mandatory);
    }

    if (selected?.by_auction_id) {
      setByAuctionId(selected.by_auction_id);
    } else {
      setByAuctionId(selected.by_auction_id);
    }

    if (selected?.by_bid_time) {
      setByBidTime(selected.by_bid_time);
    } else {
      setByBidTime(selected.by_bid_time);
    }

    if (selected?.bid_opsec_time) {
      setBidOpSecTime(selected.bid_opsec_time);
    } else {
      setBidOpSecTime(selected.bid_opsec_time);
    }

    if (selected?.bid_opsec_offset) {
      setBidOpSecOffset(selected.bid_opsec_offset);
    } else {
      setBidOpSecOffset(selected.bid_opsec_offset);
    }

    if (selected?.cooldownTime) {
      setCooldownTime(selected.cooldownTime);
    } else {
      setCooldownTime(selected.cooldownTime);
    }

    if (selected?.pprefilter) {
      setPrefilter(selected.pprefilter);
    } else {
      setPrefilter(selected.pprefilter);
    }

    if (selected?.autoIp) {
      setAutoIp(selected.autoIp);
    } else {
      setAutoIp(selected.autoIp);
    }

    if (selected?.ignore_user_proxy) {
      setIgnoreUserProxy(selected.ignore_user_proxy);
    } else {
      setIgnoreUserProxy(selected.ignore_user_proxy);
    }

    if (selected?.show_filter_errors) {
      setShowFilterErrors(selected.show_filter_errors);
    } else {
      setShowFilterErrors(selected.show_filter_errors);
    }

    if (selected?.cjsc_ignoreHttp) {
      setIgnoreHttp(selected.cjsc_ignoreHttp);
    } else {
      setIgnoreHttp(selected.cjsc_ignoreHttp);
    }

    if (selected?.show_cjsc_ignoreHttp) {
      setShowCjscIgnoreHttp(selected.show_cjsc_ignoreHttp);
    } else {
      setShowCjscIgnoreHttp(selected.show_cjsc_ignoreHttp);
    }

    if (selected?.cjsc_adUrlType) {
      setAdUrlType(selected.cjsc_adUrlType);
    } else {
      setAdUrlType(selected.cjsc_adUrlType);
    }

    if (selected?.user_type) {
      setUserType(selected.user_type);
    } else {
      setUserType(selected.user_type);
    }

    if (selected?.controlium_type) {
      setControliumType(selected.controlium_type);
    } else {
      setControliumType(selected.controlium_type);
    }

    if (selected?.require_vpn) {
      setRequireVPN(selected.require_vpn);
    } else {
      setRequireVPN(selected.require_vpn);
    }

    if (selected?.show_hash) {
      setShowHash(selected.show_hash);
    } else {
      setShowHash(selected.show_hash);
    }

    if (selected?.cjsc_logConn) {
      setLogConn(selected.cjsc_logConn);
    } else {
      setLogConn(selected.cjsc_logConn);
    }

    if (selected?.countries_type) {
      setCountriesType(selected.countries_type);
    }

    if (selected?.browsers_type) {
      setBrowsersType(selected.browsers_type);
    }

    if (selected?.oss_type) {
      setOSsType(selected.oss_type);
    }

    if (selected?.cLogger_auto_clear) {
      let getAutoClearIndexFun = (el: any) =>
        el.value === selected?.cLogger_auto_clear;
      let autoclearIndex =
        auto_clear_events_list.findIndex(getAutoClearIndexFun);
      if (autoclearIndex > -1) {
        setCloggerClearEvents(auto_clear_events_list[autoclearIndex]);
      }
    } else {
      setCloggerClearEvents("");
    }
    cjscFormik.setFieldValue("cjsc_id", selected.cjsc_id);
    cjscFormik.setFieldValue("cjsc_fifo", selected.cjsc_fifo);
    cjscFormik.setFieldValue("cjsc_multi_ipnoid", selected.cjsc_multi_ipnoid);
    cjscFormik.setFieldValue("cjsc_multi_ipid", selected.cjsc_multi_ipid);
    cjscFormik.setFieldValue("cjsc_ip", selected.cjsc_ip);
    cjscFormik.setFieldValue("cjsc_id_ip", selected.cjsc_id_ip);
    cjscFormik.setFieldValue("cjsc_ip_without_id", selected.cjsc_ip_without_id);
    cjscFormik.setFieldValue("cjsc_infinite_fifo", selected.cjsc_infinite_fifo)
    cjscFormik.setFieldValue("concat_ip", selected.concat_ip);
    cjscFormik.setFieldValue("opsec_key", selected.opsec_key);
    cjscFormik.setFieldValue("disrupt_opsec_v2",selected.disrupt_opsec_v2)
    cjscFormik.setFieldValue("freq_cap", selected.freq_cap);
    cjscFormik.setFieldValue(
      "cjsc_script",
      selected?.cjsc_script ? selected.cjsc_script : false
    );
    cjscFormik.setFieldValue(
      "cjsc_user_agent",
      selected?.cjsc_user_agent ? selected.cjsc_user_agent : false
    );
    cjscFormik.setFieldValue("panda", selected?.panda ? selected.panda : false);
    cjscFormik.setFieldValue(
      "monitor",
      selected?.monitor ? selected.monitor : false
    );
    audienceFormik.setFieldValue("audience_idfa", selected.audience_idfa);
    audienceFormik.setFieldValue("audience_ad_id", selected.audience_ad_id);
    audienceFormik.setFieldValue(
      "audience_ip_address",
      selected.audience_ip_address
    );
    audienceFormik.setFieldValue("audience_web_id", selected.audience_web_id);
    audienceFormik.setFieldValue("dsp_bw", selected.dsp_bw);
    audienceFormik.setFieldValue("dsp_mydsp", selected.dsp_mydsp);

    userInfoFormik.setFieldValue("eyield", selected.eyield);
    userInfoFormik.setFieldValue("tyield", selected.tyield);
    userInfoFormik.setFieldValue("sync_user", selected.sync_user);
    userInfoFormik.setFieldValue("sync_domain", selected.sync_domain);
    userInfoFormik.setFieldValue("ah_user", selected.ah_user);

    /*****START VALIDATE BOX VALUES ON USER CHANGE */
    if (selected.roles) {
      setIsValidateCJSCIds(false);
      setIsValidateCTargeting(false);
      setIsValidateDemoClineItem(false);
      setIsValidateProdClineItem(false);
      setIsValidateCLogger(false);
      setIsValidateGluName(false);

      let getSelectedRoleNames: any = [];
      rolesList?.forEach((x: any) => {
        if (selected.roles.includes(x._id)) {
          getSelectedRoleNames.push(x.role_name);
        }
      });
      if (getSelectedRoleNames && getSelectedRoleNames.length > 0) {
        if (getSelectedRoleNames.includes("cjsc")) {
          setIsValidateCJSCIds(true);
        }
        if (getSelectedRoleNames.includes("ctarget")) {
          setIsValidateCTargeting(true);
        }
        if (getSelectedRoleNames.includes("prod_filtering")) {
          setIsValidateProdClineItem(true);
        }
        if (getSelectedRoleNames.includes("demo_filtering")) {
          setIsValidateDemoClineItem(true);
        }
        if (getSelectedRoleNames.includes("clogger")) {
          setIsValidateCLogger(true);
        }
        if (getSelectedRoleNames.includes("glu")) {
          setIsValidateGluName(true);
        }
      }
    }
    /*****END VALIDATE BOX VALUES ON USER CHANGE */

    setTimeout(() => {
      setUsersSaveDisabled(true);
    }, 0);
  };

  const duplicateUserSuccessCallback = (user: any) => {
    let tempUserList = usersList;
    let tempSlection = user;
    setUserOptionSelected({});
    tempSlection.name = user.name;
    tempSlection.email = user.email;
    tempSlection.label = `${user.name} | ${user.email}`;
    tempUserList.push(tempSlection);
    setUsersList(tempUserList);
    setUserOptionSelected(tempSlection);
    handleChangeUser(user);
  };

  const currentScreenHandler = (screen: String) => {
    setCurrentScreen(screen);
    // if (screen === 'Roles') dispatch(GetRoleListAction())
    if (screen === "Users") dispatch(getUsersListAction());
    if (screen === "Reporting Credentials")
      dispatch(GetReportingCradicialsAction());
  };

  const newUserFormik = useFormik({
    initialValues: {
      name: "",
      email: "",
    },
    validationSchema: yup.object().shape({
      name: yup.string().required("*"),
      email: yup.string().required("*") /*.email()*/,
    }),
    onSubmit: (value, { resetForm }) => {
      const user = {
        name: value.name,
        email: value.email,
      };
      dispatch(AddNewUserAction(user));
      setUserOptionSelected({});
      resetForm({
        values: {
          name: "",
          email: "",
        },
      });
    },
  });

  const duplicateUserFormik = useFormik({
    initialValues: {
      new_name: "",
      new_email: "",
      old_name: "",
      old_email: "",
    },
    validationSchema: yup.object().shape({
      new_name: yup.string().required("*"),
      new_email: yup.string().required("*") /*.email()*/,
    }),
    onSubmit: (value, { resetForm }) => {
      const user = {
        new_name: value.new_name,
        new_email: value.new_email,
        old_email: value.old_email,
      };
      dispatch(DuplicateUserAction(user, duplicateUserSuccessCallback));

      // let tempSlection = userOptionSelected;
      // setUserOptionSelected({});
      // tempSlection.name = value.new_name;
      // tempSlection.email = value.new_email;
      // tempSlection.label = `${value.new_name} | ${value.new_email}`;
      // handleChangeUser(usersList[0]);
      // // setUserOptionSelected(tempSlection);

      resetForm({
        values: {
          new_name: "",
          new_email: "",
          old_email: "",
          old_name: "",
        },
      });
    },
  });

  const editUserFormik = useFormik({
    initialValues: {
      new_name: "",
      new_email: "",
    },
    validationSchema: yup.object().shape({
      new_name: yup.string().required("*"),
      new_email: yup.string().required("*") /*.email(),*/,
    }),
    onSubmit: (value, { resetForm }) => {
      const user = {
        new_name: value.new_name,
        new_email: value.new_email,
        prev_email: userOptionSelected.email,
      };
      dispatch(EditUserAction(user));

      /***----START: user selection with udpated values after success---- */
      let tempSlection = userOptionSelected;
      setUserOptionSelected({});
      tempSlection.name = value.new_name;
      tempSlection.email = value.new_email;
      tempSlection.label = `${value.new_name} | ${value.new_email}`;
      setUserOptionSelected(tempSlection);
      /***----END : user selection with udpated values after success---- */

      resetForm({
        values: {
          new_name: "",
          new_email: "",
        },
      });
    },
  });

  const cjscFormik = useFormik({
      initialValues: {
        cjsc_ip: false,
        cjsc_id: false,
        cjsc_id_ip: false,
        cjsc_ip_without_id: false,
        cjsc_fifo: false,
        cjsc_multi_ipnoid: false,
        cjsc_multi_ipid: false,
        cjsc_infinite_fifo: false,
        concat_ip: "off",
        opsec_key: "",
        freq_cap: false,
        cjsc_script: false,
        cjsc_user_agent: false,
        panda: false,
        monitor: false,
        disrupt_opsec_v2: false,
      },
      onSubmit: (value, { resetForm }) => {},
    });
  
  const userInfoFormik = useFormik({
    initialValues: {
      eyield: false,
      tyield: false,
      sync_user: false,
      sync_domain: false,
      ah_user: false,
    },
    onSubmit: (value, { resetForm }) => {},
  });

  const audienceFormik = useFormik({
    initialValues: {
      audience_idfa: false,
      audience_ad_id: false,
      audience_ip_address: false,
      audience_web_id: false,
      dsp_mydsp: false,
      dsp_bw: false,
    },
    onSubmit: (value, { resetForm }) => {},
  });

  useEffect(() => {
    setUsersSaveDisabled(false);
  }, [cjscFormik.values]);

  useEffect(() => {
    setUsersSaveDisabled(false);
  }, [audienceFormik.values]);

  useEffect(() => {
    setUsersSaveDisabled(false);
  }, [userInfoFormik.values]);

  const handleChangeSegments = (e: { target: { value: any } }) => {
    let value = e.target.value;
    if (/^\d+$/.test(value)) {
      return `dtech-${value}`;
    }
    setUsersSaveDisabled(false);
    return value;
  };

  const handleChangeCCreativeSegments = (e: { target: { value: any } }) => {
    let value = e.target.value;
    let segments = value.split(",").map((segment: string) => {
      segment = segment.trim();
      if (/^\d+$/.test(segment)) {
        return `dtech-${segment}`;
      }
      return segment;
    });

    setUsersSaveDisabled(false);
    return segments;
  };

  const validateAccessRoleReleventValueBox = (e: any, roleName: any) => {
    if (roleName === "cjsc") {
      setIsValidateCJSCIds(e.target.checked);
    }
    if (roleName === "ctarget") {
      setIsValidateCTargeting(e.target.checked);
    }
    if (roleName === "prod_filtering") {
      setIsValidateProdClineItem(e.target.checked);
    }
    if (roleName === "demo_filtering") {
      setIsValidateDemoClineItem(e.target.checked);
    }
    if (roleName === "clogger") {
      setIsValidateCLogger(e.target.checked);
    }
    if (roleName === "glu") {
      setIsValidateGluName(e.target.checked);
    }
  };

  //   const onChangeCjscLimitLogger =(selectionType:any)=>{

  //     if ( selectionType === "on") {
  //         const cjscLimit = true;
  //         //formik.setFieldValue("script", true);
  //     } else if (selectionType === "off") {
  //         const cjscLimit = false;
  //         //formik.setFieldValue("script", false);
  //     }
  //     cjscLimi(selectionType);
  // }

  const handleChaneUserRole = (e: any, roleId: any) => {
    const tempArr = [...userAccessRole];
    if (e.target.checked) {
      tempArr.push(roleId);
    } else if (!e.target.checked) {
      const find = tempArr.findIndex((id: any) => id === roleId);
      tempArr.splice(find, 1);
    }
    setUserAccessRole([...tempArr]);
    setUsersSaveDisabled(false);
  };

  const validateUserRole = () => {
    let errorMessages: string[] = [];
    let invalids: string[] = [];
  
    if (userType === true) {
      if (!username || !password || !clientID || !clientSecret) {
        errorMessages.push("API credentials: One or more of the credentials is missing");
        if (!username) invalids.push("username");
        if (!password) invalids.push("password");
        if (!clientID) invalids.push("clientID");
        if (!clientSecret) invalids.push("clientSecret");
      }
    }
    if (controliumType === true) {
      if (!tenantName) {
        errorMessages.push("Please fill the tenant name");
        invalids.push("tenantName");
      }
      if (!logoFolder) {
        errorMessages.push("Please fill the tenant logo folder");
        invalids.push("logoFolder");
      }
    }
    if (
      cooldown &&
      (!cooldownTime || isNaN(Number(cooldownTime)) || Number(cooldownTime) <= 0)
    ) {
      errorMessages.push("User ID Cooldown Time must be greater than 0");
      invalids.push("cooldownTime");
    }
    if (augmentor && !ctargetingUserIDs) {
      errorMessages.push("Segment must be defined for “BW User IDs Value”.");
      invalids.push("ctargetingUserIDs");
    }
    if (augmentorOpSec && !opSecBidTimer) {
      errorMessages.push("No time defined for “OpSec Bid Timer”.");
      invalids.push("opSecBidTimer");
    }
    if (autoIp == true) {
      if (!cLineItem && !cLineItemWithoutUserID && !cLineItemMyDSP && !cLineItemWithoutUserIDMyDSP) {
        errorMessages.push("Prod IP Filtering must include at least one value");
        invalids.push("cLineItem", "cLineItemWithoutUserID", "cLineItemMyDSP", "cLineItemWithoutUserIDMyDSP");
      }
      if (!ctargetingUserIDs && !cTargetingIpAddressValue && !cTargetingMobileIpAddressValue && !cTargetingIpNoId && !cTargetingMultiUid && !cTargetingMultiNoId) {
        errorMessages.push("Upload Audience must include at least one segment");
        invalids.push("ctargetingUserIDs", "cTargetingIpAddressValue", "cTargetingMobileIpAddressValue", "cTargetingIpNoId", "cTargetingMultiUid", "cTargetingMultiNoId");
      }
    }
    if (prefilter && (!prefilterIP || !destPort)) {
      errorMessages.push("Source IP and Destination Port must include values");
      if (!prefilterIP) invalids.push("prefilterIP");
      if (!destPort) invalids.push("destPort");
    }
    if (cjscFormik.values.concat_ip == "v2" && !cjscFormik.values.opsec_key) {
      errorMessages.push("Ad URL OpSec key is missing");
      invalids.push("opsec_key");
    }
    if (
      cjscLimit &&
      (maxCampPerDay <= 0 && maxCampPerMonth <= 0)
    ) {
      errorMessages.push(
        "Please define a time larger than 0 for either “Per Day” or “Per Month”"
      );
      invalids.push("maxCampPerDay", "maxCampPerMonth");
    }
    if (isValidateCLogger && !cLogger) {
      errorMessages.push("No C-Logger User key inserted!");
      invalids.push("cLogger");
    }
  
    return { errorMessages, invalids };
  };


  const handleSaveUserRole = () => {
    const { errorMessages, invalids } = validateUserRole();
    setInvalidFields(invalids);
    if (errorMessages.length > 0) {
      setValidationErrors(errorMessages);
      setShowValidationModal(true);
      return false;
    }
    setInvalidFields([]); // clear on success
    if (
      (isValidateCJSCIds && cJscId.length <= 0) ||
      (
        isValidateCTargeting &&
        !ctargetingUserIDs &&
        !cTargetingIpAddressValue &&
        !cTargetingMobileIpAddressValue &&
        !cTargetingIpNoId &&
        !cTargetingMultiUid &&
        !cTargetingMultiNoId) ||
      // (isValidateProdClineItem && !cLineItem && !cLineItemWithoutUserID) ||
      (isValidateDemoClineItem &&
        !cLineItemDemo &&
        !cLineItemDemoWithoutUserID) ||
      (isValidateCLogger && !cLogger)
      //||
      //(isValidateGluName && !gluName)
    ) {
      dispatch(
        ToastAction({
          message: `Please fill in all the required fields.`,
          severity: "Danger",
          show: true,
        })
      );
      return false;
    }
    if (cJscCallbackError && cJscCallbackURL) {
      dispatch(
        ToastAction({
          message: `Please enter valid callback URL.`,
          severity: "Danger",
          show: true,
        })
      );
      return false;
    }
    let currentUserRole = usersList.find(
      (x: any) => x._id === userOptionSelected._id
    );
    let country_code = listCountries
      ? listCountries.map((x: any) => x.value)
      : [];
    // let countries_bl = blackListCountries ? blackListCountries.map((x: any) => x.value) : [];
    let os_code = listOs ? listOs.map((x: any) => x.value) : [];
    let browser_code = listBrowsers
      ? listBrowsers.map((x: any) => x.value)
      : [];
    // let browsers_bl = blackListBrowsers ? blackListBrowsers.map((x: any) => x.value) : [];
    // let oss_bl = blackListOs ? blackListOs.map((x: any) => x.value) : [];

    let cJscId_new = cJscId ? cJscId.map((x: any) => x.value) : [];
    let clogger_clear_events = cloggerClearEvents
      ? cloggerClearEvents?.value
      : "Never";
    let cc_dsp2 = cc_dsp ? cc_dsp?.value : "beeswax";
    let cc_os2 = cc_os ? cc_os?.value : "all_oss";
    let cc_timer2 = cc_timer ? cc_timer?.value : "no";
    let cc_infinite_fifo2 = cc_infinite_fifo ? cc_infinite_fifo?.value : "no";
    let cc_ipV62 = cc_ipV6 ? cc_ipV6?.value : "no";
    let cc_noas2 = cc_noas ? cc_noas?.value : "yes";
    let cc_cookie2 = cc_cookie ? cc_cookie?.value : "yes";
    let cc_ua2 = cc_ua ? cc_ua?.value : "no";
    let cc_adv2 = cc_adv ? cc_adv?.value : "";

    if (
      (currentUserRole &&
        currentUserRole.roles?.toString() !== userAccessRole.toString()) ||
      currentUserRole.cjsc?.toString() !== cJscId.toString() ||
      currentUserRole.cjsc_ip !== cjscFormik.values.cjsc_ip ||
      currentUserRole.cjsc_id !== cjscFormik.values.cjsc_id ||
      currentUserRole.cjsc_id_ip !== cjscFormik.values.cjsc_id_ip ||
      currentUserRole.cjsc_ip_without_id !==
        cjscFormik.values.cjsc_ip_without_id ||
      currentUserRole.cjsc_fifo !== cjscFormik.values.cjsc_fifo ||
      currentUserRole.cjsc_multi_ipid !== cjscFormik.values.cjsc_multi_ipid ||
      currentUserRole.cjsc_multi_ipnoid !==
        cjscFormik.values.cjsc_multi_ipnoid ||
      currentUserRole.cjsc_infinite_fifo ! == cjscFormik.values.cjsc_infinite_fifo ||
      currentUserRole.cjsc_limit !== cjscLimit ||
      currentUserRole.wlbl_proxy !== wlblProxy ||
      currentUserRole.truncated_ips !== truncatedIPs ||
      currentUserRole.multi_campaign !== multiCampaign ||
      currentUserRole.allow_pause !== allowPause ||
      currentUserRole.allow_edit !== allowEdit ||
      currentUserRole.augmentor !== augmentor ||
      currentUserRole.augmentor_opsec !== augmentorOpSec ||
      currentUserRole.opsec_type !== opSecType ||
      currentUserRole.opsec_bid_timer !== opSecBidTimer ||
      currentUserRole.bid_opsec !== bidOpSec ||
      currentUserRole.mandatory !== mandatory ||
      currentUserRole.by_auction_id !== byAuctionId ||
      currentUserRole.by_bid_time !== byBidTime||
      currentUserRole.bid_opsec_time !== bidOpSecTime ||
      currentUserRole.bid_opsec_offset !== bidOpSecOffset ||
      currentUserRole.pprefilter !== prefilter ||
      currentUserRole.prefilter_ip !== prefilterIP ||
      currentUserRole.dest_port !== destPort ||
      currentUserRole.autoIp !== autoIp ||
      currentUserRole.ignore_user_proxy !== ignoreUserProxy ||
      currentUserRole.cjsc_adUrlType !== adUrlType ||
      currentUserRole.user_type !== userType ||
      currentUserRole.cooldown !== cooldown||
      currentUserRole.cooldownTime !== cooldownTime||
      currentUserRole.require_vpn! == requireVPN ||
      currentUserRole.controlium_type !== controliumType ||
      currentUserRole.show_hash !== showHash ||
      currentUserRole.cjsc_logConn !== logConn ||
      currentUserRole.cjsc_ignoreHttp !== ignoreHttp ||
      currentUserRole.show_cjsc_ignoreHttp !== showCjscIgnoreHttp ||
      currentUserRole.max_camp_per_day !== maxCampPerDay ||
      currentUserRole.max_camp_per_month !== maxCampPerMonth ||
      currentUserRole.concat_ip !== cjscFormik.values.concat_ip ||
      currentUserRole.opsec_key !== cjscFormik.values.opsec_key ||
      currentUserRole.disrupt_opsec_v2 ! == cjscFormik.values.disrupt_opsec_v2 ||
      currentUserRole.freq_cap !== cjscFormik.values.freq_cap ||
      currentUserRole.cjsc_script !== cjscFormik.values.cjsc_script ||
      currentUserRole.cjsc_user_agent !== cjscFormik.values.cjsc_user_agent ||
      currentUserRole.panda !== cjscFormik.values.panda ||
      currentUserRole.monitor !== cjscFormik.values.monitor ||
      currentUserRole.line_item_id !== cLineItem ||
      currentUserRole.line_item_id_demo !== cLineItemDemo ||
      currentUserRole.line_item_id_mydsp !== cLineItemMyDSP ||
      currentUserRole.line_item_id_demo !== cLineItemDemoMyDSP ||
      currentUserRole.line_item_without_id !== cLineItemWithoutUserID ||
      currentUserRole.line_item_withour_id_demo !==
        cLineItemDemoWithoutUserID ||
      currentUserRole.line_item_without_id_mydsp !==
        cLineItemWithoutUserIDMyDSP ||
      currentUserRole.line_item_withour_id_demo_mydsp !==
        cLineItemDemoWithoutUserIDMyDSP ||
      currentUserRole.cLogger_id !== cLogger ||
      currentUserRole.username !== username ||
      currentUserRole.password! == password ||
      currentUserRole.client_id! == clientID ||
      currentUserRole.client_secret! == clientSecret ||
      currentUserRole.tenant_name !== tenantName ||
      currentUserRole.logo_folder !== logoFolder ||
      currentUserRole.ip_restrict_from !== userIPRestrictionFrom ||
      currentUserRole.ip_restrict_to !== userIPRestrictionTo ||
      currentUserRole.glu_name !== gluName ||
      currentUserRole.beeswax_cid !== beeswaxCID ||
      currentUserRole.dash_monthly_budget !== dashMonthlyBudget ||
      currentUserRole.countries !== country_code ||
      // currentUserRole.bl_countries !== countries_bl ||
      currentUserRole.browsers !== browser_code ||
      // currentUserRole.bl_browsers !== browsers_bl ||
      currentUserRole.oss !== os_code ||
      // currentUserRole.oss_bl !== oss_bl ||
      currentUserRole?.cLogger_auto_clear !== clogger_clear_events ||
      currentUserRole?.ccreative_folder !== ccreative_folder ||
      currentUserRole?.cc_lineItems !== cc_lineItems ||
      currentUserRole?.cc_dsp !== cc_dsp2 ||
      currentUserRole?.cc_adv !== cc_adv2 ||
      currentUserRole?.cc_os !== cc_os2 ||
      currentUserRole?.cc_noas !== cc_noas2 ||
      currentUserRole?.cc_cookie !== cc_cookie2 ||
      currentUserRole?.cc_ua !== cc_ua2 ||
      currentUserRole?.cc_timer !== cc_timer2 ||
      currentUserRole?.cc_infinte_fifo !== cc_infinite_fifo2 ||
      currentUserRole?.cc_ipV6 !=cc_ipV62||
      currentUserRole.audience_idfa !== audienceFormik.values.audience_idfa ||
      currentUserRole.audience_ad_id !== audienceFormik.values.audience_ad_id ||
      currentUserRole.audience_ip_address !==
        audienceFormik.values.audience_ip_address ||
      currentUserRole.audience_web_id !==
        audienceFormik.values.audience_web_id ||
      currentUserRole.dsp_bw !== audienceFormik.values.dsp_bw ||
      currentUserRole.dsp_mydsp !== audienceFormik.values.dsp_mydsp ||
      currentUserRole.show_filter_errors !== showFilterErrors ||
      currentUserRole.eyield !== userInfoFormik.values.eyield ||
      currentUserRole.tyield !== userInfoFormik.values.tyield ||
      currentUserRole.sync_user !== userInfoFormik.values.sync_user ||
      currentUserRole.sync_domain !== userInfoFormik.values.sync_domain ||
      currentUserRole.ah_user !== userInfoFormik.values.ah_user
    ) {
      dispatch(
        ChangedUserRoleAction({
          id: userOptionSelected._id,
          roles: userAccessRole,
          cJscId: cJscId_new,
          ctarget_id: ctargetingUserIDs,
          ctarget_ip: cTargetingIpAddressValue,
          ctarget_mobile_ip: cTargetingMobileIpAddressValue,
          ctarget_ip_no_id: cTargetingIpNoId,
          ctarget_multi_uid: cTargetingMultiUid,
          ctarget_multi_no_id: cTargetingMultiNoId,
          ctarget_ccreative: cTargetingCCreativeValue,

          ctarget_ip_mydsp: cTargetingIPMyDSP,
          ctarget_web_mydsp: cTargetingWebMyDSP,
          ctarget_idfa_mydsp: cTargetingIDFA,
          ctarget_gaid_mydsp: cTargetingGAID,

          cjsc_id: cjscFormik.values.cjsc_id,
          cjsc_fifo: cjscFormik.values.cjsc_fifo,
          cjsc_multi_ipid: cjscFormik.values.cjsc_multi_ipid,
          cjsc_multi_ipnoid: cjscFormik.values.cjsc_multi_ipnoid,
          cjsc_ip: cjscFormik.values.cjsc_ip,
          cjsc_id_ip: cjscFormik.values.cjsc_id_ip,
          cjsc_ip_without_id: cjscFormik.values.cjsc_ip_without_id,
          cjsc_infinite_fifo:cjscFormik.values.cjsc_infinite_fifo,
          concat_ip: cjscFormik.values.concat_ip,
          opsec_key: cjscFormik.values.opsec_key,
          disrupt_opsec_v2: cjscFormik.values.disrupt_opsec_v2,
          freq_cap: cjscFormik.values.freq_cap,
          cjsc_script: cjscFormik.values.cjsc_script,
          cjsc_user_agent: cjscFormik.values.cjsc_user_agent,
          panda: cjscFormik.values.panda,
          monitor: cjscFormik.values.monitor,
          line_item_id: cLineItem,
          line_item_without_id: cLineItemWithoutUserID,
          line_item_id_demo: cLineItemDemo,
          line_item_without_id_demo: cLineItemDemoWithoutUserID,
          line_item_id_mydsp: cLineItemMyDSP,
          line_item_without_id_mydsp: cLineItemWithoutUserIDMyDSP,
          line_item_id_demo_mydsp: cLineItemDemoMyDSP,
          line_item_without_id_demo_mydsp: cLineItemDemoWithoutUserIDMyDSP,
          cLogger_id: cLogger,
          username: username,
          password: password,
          client_id: clientID,
          client_secret: clientSecret,
          tenant_name: tenantName,
          logo_folder: logoFolder,
          glu_name: gluName,
          beeswax_cid: beeswaxCID,
          dash_monthly_budget: dashMonthlyBudget,
          ip_restrict_from: userIPRestrictionFrom,
          ip_restrict_to: userIPRestrictionTo,
          countries: country_code,
          countries_type: countriesType,
          // bl_countries: countries_bl,
          browsers: browser_code,
          browsers_type: browsersType,
          // bl_browsers:browsers_bl,
          oss: os_code,
          oss_type: ossType,
          // bl_oss: oss_bl,
          cjsc_ad_url_whitelist: cJscURLWhiteList,
          cjsc_limit: cjscLimit,
          wlbl_proxy: wlblProxy,
          truncated_ips: truncatedIPs,
          multi_campaign: multiCampaign,
          cooldown:cooldown,
          cooldownTime:cooldownTime,
          allow_pause: allowPause,
          allow_edit: allowEdit,
          augmentor: augmentor,
          augmentor_opsec: augmentorOpSec,
          opsec_type: opSecType,
          opsec_bid_timer: opSecBidTimer,
          bid_opsec: bidOpSec,
          mandatory:mandatory,
          by_auction_id:byAuctionId,
          by_bid_time:byBidTime,
          bid_opsec_time:bidOpSecTime,
          bid_opsec_offset:bidOpSecOffset,
          pprefilter: prefilter,
          prefilter_ip: prefilterIP,
          dest_port: destPort,
          autoIp: autoIp,
          ignore_user_proxy: ignoreUserProxy,
          cjsc_ignoreHttp: ignoreHttp,
          show_cjsc_ignoreHttp: showCjscIgnoreHttp,
          cjsc_adUrlType: adUrlType,
          user_type: userType,
          require_vpn: requireVPN,
          controlium_type: controliumType,
          show_hash: showHash,
          cjsc_logConn: logConn,
          max_camp_per_day: maxCampPerDay,
          max_camp_per_month: maxCampPerMonth,
          cjsc_callback_url: cJscCallbackURL,
          cjsc_callback_type: cjscCallbackType,
          cLogger_auto_clear: clogger_clear_events,
          cc_folder: ccreative_folder,
          cc_lineItems: cc_lineItems,
          cc_dsp: cc_dsp2,
          cc_adv: cc_adv2,
          cc_os: cc_os2,
          cc_noas: cc_noas2,
          cc_cookie: cc_cookie2,
          cc_ua: cc_ua2,
          cc_timer: cc_timer2,
          cc_infinite_fifo: cc_infinite_fifo2,
          cc_ipV6: cc_ipV62,
          audience_idfa: audienceFormik.values.audience_idfa,
          audience_ad_id: audienceFormik.values.audience_ad_id,
          audience_ip_address: audienceFormik.values.audience_ip_address,
          audience_web_id: audienceFormik.values.audience_web_id,
          dsp_bw: audienceFormik.values.dsp_bw,
          dsp_mydsp: audienceFormik.values.dsp_mydsp,
          show_filter_errors: showFilterErrors,
          eyield: userInfoFormik.values.eyield,
          tyield: userInfoFormik.values.tyield,
          sync_user: userInfoFormik.values.sync_user,
          sync_domain: userInfoFormik.values.sync_domain,
          ah_user: userInfoFormik.values.ah_user,
        })
      );
      dispatch(getUsersListAction());
    }
    setUsersSaveDisabled(true);
  };

  const handleDeleteUser = () => {
    let userEmail = userOptionSelected;
    dispatch(DeleteUserAction(userEmail));
    setShowErrorModal(false);
    handleChangeUser(usersList[0]);
  };

  const handleRemoveToken = () => {
    let userEmail = userOptionSelected;
    dispatch(removeUserTokenAction(userEmail));
    setShowRemoveTokenModal(false);
  };

  const handleSaveRoleAccess = () => {
    //#####
    let currentRole = rolesList.find((x) => x._id === optionSelected._id);
    if (
      currentRole &&
      currentRole.access_screen?.toString() !== roleAccessPage.toString()
    ) {
      dispatch(
        ChangedRoleAccessScreenAction({
          id: optionSelected._id,
          access_screen: roleAccessPage,
        })
      );
      dispatch(GetRoleListAction());
    }
  };

  const handleEditUser = () => {
    editUserFormik.setFieldValue("new_name", userOptionSelected.name);
    editUserFormik.setFieldValue("new_email", userOptionSelected.email);
    setVisibleEditUser(true);
  };

  const handleDuplicateUser = () => {
    duplicateUserFormik.setFieldValue("old_name", userOptionSelected.name);
    duplicateUserFormik.setFieldValue("old_email", userOptionSelected.email);
    setVisibleDuplicateUser(true);
  };

  const validateIPAddress = (value: any, updateFunction: any) => {
    if (value) {
      let checkIp = new RegExp(
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
      );
      if (checkIp.test(value)) {
        updateFunction(false);
        setUsersSaveDisabled(false);
      } else {
        updateFunction(true);
        setUsersSaveDisabled(true);
      }
    } else {
      updateFunction(false); //DUE TO NOT MANDATORY FIELD
      setUsersSaveDisabled(false); //DUE TO NOT MANDATORY FIELD
    }
  };

  const validateSpecialCharacter = (str: any) => {
    ///#####
    const specialChars = new RegExp(/^[a-z\d\s]+$/i);
    return specialChars.test(str);
  };
  const validateURL = (str: any) => {
    const specialChars = new RegExp(
      /https?:\/\/(?:w{1,3}\.)?[^\s.]+(?:\.[a-z0-9]+)(?::\d+)?(?![^<](?:<\/\w+>|\/?>))/g
    );
    return specialChars.test(str);
  };

  const handleDomainWhitelistUpload = (event: any) => {
    const fileObj = event.target.files && event.target.files[0];
    if (!fileObj) {
      return;
    }
    const formData = new FormData();
    formData.append("csvfile", fileObj);
    dispatch(UploadDomainWhitelistCSVAction(formData, userOptionSelected._id));
  };

  const handleUploadDomainCSV = () => {
    if (domainWhitelistUploadRef) {
      domainWhitelistUploadRef?.current?.click();
    }
  };

  const handleAppWhitelistUpload = (event: any) => {
    const fileObj = event.target.files && event.target.files[0];
    if (!fileObj) {
      return;
    }
    const formData = new FormData();
    formData.append("csvfile", fileObj);
    dispatch(UploadAppWhitelistCSVAction(formData, userOptionSelected._id));
  };

  const handleUploadAppCSV = () => {
    if (domainAppUploadRef) {
      domainAppUploadRef?.current?.click();
    }
  };

  const handleWhiltelistDelete = () => {
    dispatch(
      deleteWhitelistAction({
        userId: userOptionSelected._id,
        whitelistType: deleteWhiteListType,
      })
    );
    setShowDeleteWhiteList(false);
    setDeleteWhiteListType("");
  };

  const handleCallbackTypeSelection = (callbackType: any) => {
    if (
      ["off", "event_logger", "api", "api_and_logger"].includes(callbackType)
    ) {
      setCJscCallbackURL("");
      setUsersSaveDisabled(false);
    } else {
      if (cJscCallbackURL) {
        setUsersSaveDisabled(false);
      }
    }
    setCjscCallbackType(callbackType);
  };

  const onChangeTargetLogger = (selectionType: any) => {
    if (selectionType === "on") {
      setCjscLimit(true);
    } else if (selectionType === "off") {
      setCjscLimit(false);
    }
    setUsersSaveDisabled(false);
  };

  const onChangeWLBLProxy = (selectionType: any) => {
    if (selectionType === "on") {
      setWLBLProxy(true);
    } else if (selectionType === "off") {
      setWLBLProxy(false);
    }
    setUsersSaveDisabled(false);
  };

  const onChangeTruncatedIPs = (selectionType: any) => {
    if (selectionType === "on") {
      setTruncatedIPs(true);
    } else if (selectionType === "off") {
      setTruncatedIPs(false);
    }
    setUsersSaveDisabled(false);
  };

  const onChangeMultiCampaign = (selectionType: any) => {
    if (selectionType === "on") {
      setMultiCampaign(true);
    } else if (selectionType === "off") {
      setMultiCampaign(false);
    }
    setUsersSaveDisabled(false);
  };

  const onChangeCooldown = (selectionType: any) => {
    if (selectionType === "on") {
      setCooldown(true);
    } else if (selectionType === "off") {
      setCooldown(false);
    }
    setUsersSaveDisabled(false);
  };


  const onChangeAllowPause = (selectionType: any) => {
    if (selectionType === "on") {
      setAllowPause(true);
    } else if (selectionType === "off") {
      setAllowPause(false);
    }
    setUsersSaveDisabled(false);
  };

  const onChangeAllowEdit = (selectionType: any) => {
    if (selectionType === "on") {
      setAllowEdit(true);
    } else if (selectionType === "off") {
      setAllowEdit(false);
    }
    setUsersSaveDisabled(false);
  };

  const onChangeAugmentor = (selectionType: any) => {
    if (selectionType === "on") {
      setAugmentor(true);
    } else if (selectionType === "off") {
      setAugmentor(false);
    }
    setUsersSaveDisabled(false);
  };

  const onChangeAugmentorOpSec = (selectionType: any) => {
    if (selectionType === "on") {
      setAugmentorOpSec(true);
    } else if (selectionType === "off") {
      setAugmentorOpSec(false);
    }
    setUsersSaveDisabled(false);
  };

  const onChangeOpSecType = (selectionType: any) => {
    if (selectionType === "on") {
      setOpSecType(true);
    } else if (selectionType === "off") {
      setOpSecType(false);
    }
    setUsersSaveDisabled(false);
  };

  const onChangeBidOpSec = (selectionType: any) => {
    if (selectionType === "on") {
      setBidOpSec(true);
    } else if (selectionType === "off") {
      setBidOpSec(false);
    }
    setUsersSaveDisabled(false);
  };

  const onChangeMandatory = (selectionType: any) => {
    if (selectionType === "on") {
      setMandatory(true);
    } else if (selectionType === "off") {
      setMandatory(false);
    }
    setUsersSaveDisabled(false);
  };
  
  const onChangeByAuctionId = (selectionType: any) => {
    if (selectionType === "on") {
      setByAuctionId(true);
    } else if (selectionType === "off") {
      setByAuctionId(false);
    }
    setUsersSaveDisabled(false);
  };

  const onChangeByBidTime = (selectionType: any) => {
    if (selectionType === "on") {
      setByBidTime(true);
    } else if (selectionType === "off") {
      setByBidTime(false);
    }
    setUsersSaveDisabled(false);
  };

  

  


  const onChangePrefilter = (selectionType: any) => {
    if (selectionType === "on") {
      setPrefilter(true);
    } else if (selectionType === "off") {
      setPrefilter(false);
    }
    setUsersSaveDisabled(false);
  };

  const onChangeAutoIP = (selectionType: any) => {
    if (selectionType === "on") {
      setAutoIp(true);
    } else if (selectionType === "off") {
      setAutoIp(false);
    }
    setUsersSaveDisabled(false);
  };

  const onChangeIgnoreUserProxy = (selectionType: any) => {
    if (selectionType === "on") {
      setIgnoreUserProxy(true);
    } else if (selectionType === "off") {
      setIgnoreUserProxy(false);
    }
    setUsersSaveDisabled(false);
  };

  const onChangeShowFilterErrors = (selectionType: any) => {
    if (selectionType === "on") {
      setShowFilterErrors(true);
    } else if (selectionType === "off") {
      setShowFilterErrors(false);
    }
    setUsersSaveDisabled(false);
  };

  const onChangeIgnoreHttp = (selectionType: any) => {
    if (selectionType === "on") {
      setIgnoreHttp(true);
    } else if (selectionType === "off") {
      setIgnoreHttp(false);
    }
    setUsersSaveDisabled(false);
  };

  const onChangeShowCjscIgnoreHttp = (selectionType: any) => {
    if (selectionType === "on") {
      setShowCjscIgnoreHttp(true);
    } else if (selectionType === "off") {
      setShowCjscIgnoreHttp(false);
    }
    setUsersSaveDisabled(false);
  };

  const onChangeAdUrlType = (selectionType: any) => {
    if (selectionType === "on") {
      setAdUrlType(true);
    } else if (selectionType === "off") {
      setAdUrlType(false);
    }
    setUsersSaveDisabled(false);
  };

  const onChangeUserType = (selectionType: any) => {
    if (selectionType === "on") {
      setUserType(true);
    } else if (selectionType === "off") {
      setUserType(false);
    }
    setUsersSaveDisabled(false);
  };
  const onChangeRequireVPN = (selectionType: any) => {
    if (selectionType === "on") {
      setRequireVPN(true);
    } else if (selectionType === "off") {
      setRequireVPN(false);
    }
    setUsersSaveDisabled(false);
  };

  const onChangeControliumType = (selectionType: any) => {
    if (selectionType === "on") {
      setControliumType(true);
    } else if (selectionType === "off") {
      setControliumType(false);
    }
    setUsersSaveDisabled(false);
  };

  const onChangeShowHash = (selectionType: any) => {
    if (selectionType === "on") {
      setShowHash(true);
    } else if (selectionType === "off") {
      setShowHash(false);
    }
    setUsersSaveDisabled(false);
  };

  const onChangeLogConn = (selectionType: any) => {
    if (selectionType === "on") {
      setLogConn(true);
    } else if (selectionType === "off") {
      setLogConn(false);
    }
    setUsersSaveDisabled(false);
  };

  //CREATIVE-UPLOAD
  const dspOptions = [{ value: "beeswax", label: "Beeswax" }];
  const OsOptions = [
    { value: "android", label: "Android" },
    { value: "ios", label: "iOS" },
    { value: "all_oss", label: "All_OSs" },
  ];
  //const tagOptions = [{ value: "regular", label: "Regular" }];
  const yesnoOptions = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ];

  const MultiValueRemove = (props: any) => {
    const isLocked = props.data.value === userOptionSelected._id;
    if (isLocked) return null;
    return <components.MultiValueRemove {...props} />;
  };

  const MultiValueLabel = (props: any) => {
    const isLocked = props.data.value === userOptionSelected._id;
    return (
      <components.MultiValueLabel {...props}>
        {isLocked && (
          <Lock size={14} color="#888" style={{ marginRight: 5 }} />
        )}
        {props.children}
      </components.MultiValueLabel>
    );
  };


  return (
    <Row className="d-flex justify-content-center mt-3">
      <Col className="transperent">
        <div>
          <div className="menu_tabs">
            <Tab.Container defaultActiveKey="Logger">
              <Nav
                style={{ width: "20%" }}
                as="ul"
                justify
                variant="pills"
                className="p-1"
              >
                <Nav.Item as="li" key={"Logger"}>
                  <Nav.Link
                    onClick={() => {
                      currentScreenHandler("Logger");
                    }}
                    className="cursor-pointer"
                    eventKey={"Logger"}
                  >
                    <span className="d-none d-sm-block">Logger</span>
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              <Nav
                style={{ width: "20%" }}
                as="ul"
                justify
                variant="pills"
                className="p-1"
              >
                <Nav.Item as="li" key={"Account Mgmt"}>
                  <Nav.Link
                    onClick={() => {
                      currentScreenHandler("Account Mgmt");
                    }}
                    className="cursor-pointer"
                    eventKey={"Account Mgmt"}
                  >
                    <span className="d-none d-sm-block">Account Mgmt</span>
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              <Nav
                style={{ width: "20%" }}
                as="ul"
                justify
                variant="pills"
                className="p-1"
              >
                <Nav.Item as="li" key={"Roles"}>
                  <Nav.Link
                    onClick={() => currentScreenHandler("Roles")}
                    className="cursor-pointer"
                    eventKey={"Roles"}
                  >
                    <span className="d-none d-sm-block">Roles</span>
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              <Nav
                style={{ width: "20%" }}
                as="ul"
                justify
                variant="pills"
                className="p-1"
              >
                <Nav.Item as="li" key={"Users"}>
                  <Nav.Link
                    onClick={() => currentScreenHandler("Users")}
                    className="cursor-pointer"
                    eventKey={"Users"}
                  >
                    <span className="d-none d-sm-block">Users</span>
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              <Nav
                style={{ width: "20%" }}
                as="ul"
                justify
                variant="pills"
                className="p-1"
              >
                <Nav.Item as="li" key={"Reporting Credentials"}>
                  <Nav.Link
                    onClick={() =>
                      currentScreenHandler("Reporting Credentials")
                    }
                    className="cursor-pointer"
                    eventKey={"Reporting Credentials"}
                  >
                    <span className="d-none d-sm-block">
                      Reporting Credentials
                    </span>
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Tab.Container>
          </div>

          <div className="tab-box">
            {/* <h3>{currentScreen}</h3> */}

            {currentScreen === "Account Mgmt" && <AccountMgmtTab />}

            {currentScreen === "Roles" && <RolesTab />}

            {currentScreen === "Users" && (
              <>
                <Modal
                  show={isPopUp}
                  onHide={() => {
                    setIsPopUp(false);
                  }}
                >
                  <Modal.Header
                    style={{ borderBottom: "0" }}
                    onHide={() => {
                      setIsPopUp(false);
                    }}
                    closeButton
                  >
                    <Modal.Title
                      as="h4"
                      style={{ fontSize: ".9375rem", fontWeight: "700" }}
                    >
                      Add New User
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Form.Label
                        column
                        lg={4}
                        htmlFor="simpleinput"
                        id="smallerFontSize"
                      >
                        Name
                        {newUserFormik.errors.name && (
                          <span
                            style={{
                              color: "#dc3545",
                              fontFamily: "Silka",
                              fontSize: 12,
                            }}
                          >
                            {newUserFormik.errors.name}
                          </span>
                        )}
                      </Form.Label>
                      <Col lg={8}>
                        <FormControl
                          name="name"
                          defaultValue={newUserFormik.values.name}
                          onChange={newUserFormik.handleChange}
                          onBlur={newUserFormik.handleBlur}
                        ></FormControl>
                      </Col>
                    </Form.Group>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Form.Label
                        column
                        lg={4}
                        htmlFor="simpleinput"
                        id="smallerFontSize"
                      >
                        Email Address
                        {newUserFormik.errors.email && (
                          <span
                            style={{
                              color: "#dc3545",
                              fontFamily: "Silka",
                              fontSize: 12,
                            }}
                          >
                            {newUserFormik.errors.email}
                          </span>
                        )}
                      </Form.Label>
                      <Col lg={8}>
                        <FormControl
                          name="email"
                          defaultValue={newUserFormik.values.email}
                          onChange={newUserFormik.handleChange}
                          onBlur={newUserFormik.handleBlur}
                        ></FormControl>
                      </Col>
                    </Form.Group>
                  </Modal.Body>
                  <Modal.Footer style={{ borderTop: "0" }}>
                    <Button
                      variant="light"
                      onClick={() => {
                        setIsPopUp(false);
                        newUserFormik.resetForm({
                          values: {
                            name: "",
                            email: "",
                          },
                        });
                      }}
                    >
                      Close
                    </Button>
                    <Button
                      variant="primary"
                      onClick={() => {
                        if (
                          JSON.stringify(newUserFormik.errors) === "{}" &&
                          JSON.stringify(newUserFormik.touched) !== "{}"
                        ) {
                          newUserFormik.handleSubmit();
                          setIsPopUp(false);
                        }
                      }}
                    >
                      Save changes
                    </Button>
                  </Modal.Footer>
                </Modal>

                <Modal
                  show={visibleDuplicateUser}
                  onHide={() => {
                    setVisibleDuplicateUser(false);
                  }}
                >
                  <Modal.Header
                    style={{ borderBottom: "0" }}
                    onHide={() => {
                      setVisibleDuplicateUser(false);
                    }}
                    closeButton
                  >
                    <Modal.Title
                      as="h4"
                      style={{ fontSize: ".9375rem", fontWeight: "700" }}
                    >
                      Duplicate User
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Header>
                    <Modal.Title
                      as="h4"
                      style={{ fontSize: ".9375rem", fontWeight: "700" }}
                    >
                      User to duplicate : {duplicateUserFormik.values.old_name}
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Form.Label
                        column
                        lg={4}
                        htmlFor="simpleinput"
                        id="smallerFontSize"
                      >
                        Name
                        {duplicateUserFormik.errors.new_name && (
                          <span
                            style={{
                              color: "#dc3545",
                              fontFamily: "Silka",
                              fontSize: 12,
                            }}
                          >
                            {duplicateUserFormik.errors.new_name}
                          </span>
                        )}
                      </Form.Label>
                      <Col lg={8}>
                        <FormControl
                          name="new_name"
                          // defaultValue={}
                          onChange={duplicateUserFormik.handleChange}
                          onBlur={duplicateUserFormik.handleBlur}
                        ></FormControl>
                      </Col>
                    </Form.Group>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Form.Label
                        column
                        lg={4}
                        htmlFor="simpleinput"
                        id="smallerFontSize"
                      >
                        Email Address
                        {duplicateUserFormik.errors.new_email && (
                          <span
                            style={{
                              color: "#dc3545",
                              fontFamily: "Silka",
                              fontSize: 12,
                            }}
                          >
                            {duplicateUserFormik.errors.new_email}
                          </span>
                        )}
                      </Form.Label>
                      <Col lg={8}>
                        <FormControl
                          name="new_email"
                          // defaultValue={}
                          onChange={duplicateUserFormik.handleChange}
                          onBlur={duplicateUserFormik.handleBlur}
                        ></FormControl>
                      </Col>
                    </Form.Group>
                  </Modal.Body>
                  <Modal.Footer style={{ borderTop: "0" }}>
                    <Button
                      variant="light"
                      onClick={() => {
                        setVisibleDuplicateUser(false);
                        duplicateUserFormik.resetForm({
                          values: {
                            new_name: "",
                            new_email: "",
                            old_email: "",
                            old_name: "",
                          },
                        });
                      }}
                    >
                      Close
                    </Button>
                    <Button
                      variant="primary"
                      onClick={() => {
                        if (
                          JSON.stringify(duplicateUserFormik.errors) === "{}" &&
                          JSON.stringify(duplicateUserFormik.touched) !== "{}"
                        ) {
                          duplicateUserFormik.handleSubmit();
                          setVisibleDuplicateUser(false);
                        }
                      }}
                    >
                      Duplicate
                    </Button>
                  </Modal.Footer>
                </Modal>

                <Modal
                  show={visibleEditUser}
                  onHide={() => {
                    setVisibleEditUser(false);
                  }}
                >
                  <Modal.Header
                    style={{ borderBottom: "0" }}
                    onHide={() => {
                      setVisibleEditUser(false);
                    }}
                    closeButton
                  >
                    <Modal.Title
                      as="h4"
                      style={{ fontSize: ".9375rem", fontWeight: "700" }}
                    >
                      Edit User
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Form.Label
                        column
                        lg={4}
                        htmlFor="simpleinput"
                        id="smallerFontSize"
                      >
                        Name
                        {editUserFormik.errors.new_name && (
                          <span
                            style={{
                              color: "#dc3545",
                              fontFamily: "Silka",
                              fontSize: 12,
                            }}
                          >
                            {editUserFormik.errors.new_name}
                          </span>
                        )}
                      </Form.Label>
                      <Col lg={8}>
                        <FormControl
                          name="new_name"
                          defaultValue={editUserFormik.values.new_name}
                          onChange={editUserFormik.handleChange}
                          onBlur={editUserFormik.handleBlur}
                        ></FormControl>
                      </Col>
                    </Form.Group>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Form.Label
                        column
                        lg={4}
                        htmlFor="simpleinput"
                        id="smallerFontSize"
                      >
                        Email Address
                        {editUserFormik.errors.new_email && (
                          <span
                            style={{
                              color: "#dc3545",
                              fontFamily: "Silka",
                              fontSize: 12,
                            }}
                          >
                            {editUserFormik.errors.new_email}
                          </span>
                        )}
                      </Form.Label>
                      <Col lg={8}>
                        <FormControl
                          name="new_email"
                          defaultValue={editUserFormik.values.new_email}
                          onChange={editUserFormik.handleChange}
                          onBlur={editUserFormik.handleBlur}
                        ></FormControl>
                      </Col>
                    </Form.Group>
                  </Modal.Body>
                  <Modal.Footer style={{ borderTop: "0" }}>
                    <Button
                      variant="light"
                      onClick={() => {
                        setVisibleEditUser(false);
                        editUserFormik.resetForm({
                          values: {
                            new_name: "",
                            new_email: "",
                          },
                        });
                      }}
                    >
                      Close
                    </Button>
                    <Button
                      variant="primary"
                      onClick={() => {
                        if (
                          JSON.stringify(editUserFormik.errors) === "{}" &&
                          JSON.stringify(editUserFormik.touched) !== "{}"
                        ) {
                          editUserFormik.handleSubmit();
                          setVisibleEditUser(false);
                        }
                      }}
                    >
                      Save changes
                    </Button>
                  </Modal.Footer>
                </Modal>

                <Modal
                  show={showErrorModal}
                  onHide={() => setShowErrorModal(false)}
                  centered
                >
                  <Modal.Body className="text-center">
                    <i className="uil-no-entry text-warning display-3"></i>
                    <h4 style={{ color: "#ff5c75" }} className="mt-4">
                      Delete User
                    </h4>
                    <p className="w-75 mx-auto text-muted">
                      Are you sure you want to delete this User?
                    </p>
                    <div className="mt-4">
                      <Button
                        onClick={() => {
                          handleDeleteUser();
                        }}
                        variant="danger"
                      >
                        Yes, Delete User
                      </Button>
                      <Button
                        onClick={() => {
                          setShowErrorModal(false);
                        }}
                        variant="secondary"
                      >
                        Cancel
                      </Button>
                    </div>
                  </Modal.Body>
                </Modal>

                <Modal
                  show={showDeleteWhiteList}
                  onHide={() => {
                    setShowDeleteWhiteList(false);
                    setDeleteWhiteListType("");
                  }}
                  centered
                >
                  <Modal.Body className="text-center">
                    <i className="uil-no-entry text-warning display-3"></i>
                    <h4 style={{ color: "#ff5c75" }} className="mt-4">
                      Delete Whitelist
                    </h4>
                    <p className="w-75 mx-auto text-muted">
                      Are you sure you want to delete this whitelist?
                    </p>
                    <div className="mt-4">
                      <Button
                        onClick={() => {
                          setShowDeleteWhiteList(false);
                          setDeleteWhiteListType("");
                        }}
                        variant="secondary"
                      >
                        Cancel
                      </Button>
                      <Button
                        onClick={() => handleWhiltelistDelete()}
                        variant="danger"
                      >
                        Delete
                      </Button>
                    </div>
                  </Modal.Body>
                </Modal>

                <Modal
                  show={showRemoveTokenModal}
                  onHide={() => setShowRemoveTokenModal(false)}
                  centered
                >
                  <Modal.Body className="text-center">
                    <i className="uil-no-entry text-warning display-3"></i>
                    <h4 style={{ color: "#ff5c75" }} className="mt-4">
                      Delete Token
                    </h4>
                    <p className="w-75 mx-auto text-muted">
                      Are you sure you want to delete this user token?
                    </p>
                    <div className="mt-4">
                      <Button
                        onClick={() => {
                          handleRemoveToken();
                        }}
                        variant="danger"
                      >
                        Yes, Delete token
                      </Button>
                      <Button
                        onClick={() => {
                          setShowRemoveTokenModal(false);
                        }}
                        variant="secondary"
                      >
                        Cancel
                      </Button>
                    </div>
                  </Modal.Body>
                </Modal>
              </>
            )}

            {currentScreen === "Reporting Credentials" && <ReportingTab />}

            {currentScreen === "Logger" && <LoggerTab />}
          </div>
          {currentScreen === "Users" && (
            <>
              <Modal show={showValidationModal} onHide={() => setShowValidationModal(false)} centered>
                <Modal.Header closeButton>
                  <Modal.Title>Validation Errors</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {validationErrors.map((err, idx) => (
                    <div key={idx}>
                      <div>{err}</div>
                      {idx < validationErrors.length - 1 && <hr />}
                    </div>
                  ))}
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="light" onClick={() => setShowValidationModal(false)}>
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
              <Row style={{ marginBottom: "15px" }}>
                <Col lg={12}>
                  <div className="d-flex flex-wrap flex-md-row flex-column justify-content-between button-row">
                    <div className="d-flex flex-wrap justify-content-between flex-sm-row flex-column gap-2">
                      <Button
                        className="order-11 m-0 yellow-btn"
                        variant="warning"
                        onClick={() => navigate("/usage_report")}
                      >
                        Usage Report
                      </Button>
                      <Button
                        className="order-11 m-0 mr-2"
                        variant="secondary"
                        onClick={() => dispatch(getUserPermissionsAction())}
                      >
                        Export All Permissions
                      </Button>
                    </div>
                    <div className="mt-2 mt-md-0">
                      <Button
                        className="order-11 m-0"
                        variant="primary"
                        onClick={() => {
                          setIsPopUp(true);
                        }}
                      >
                        +Add User
                      </Button>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <Card>
                    <Card.Body>
                      <div className="d-flex flex-wrap flex-md-row flex-column justify-content-between button-row">
                        <div className="d-flex flex-wrap justify-content-between flex-sm-row flex-column">
                          <Select
                            className="react-select react-select-container fsz-875rem"
                            classNamePrefix="react-select"
                            onChange={handleChangeUser}
                            name="users"
                            options={usersList}
                            hideSelectedOptions={false}
                            // closeMenuOnSelect={true}
                            placeholder="Choose User"
                            defaultValue="Choose User"
                            value={userOptionSelected}
                            maxMenuHeight={100}
                          />

                          <div className="mt-2 mt-sm-0">
                            <Button
                              className="order-11 m-0 blue-btn"
                              variant=""
                              onClick={() => {
                                handleEditUser();
                              }}
                              disabled={userOptionSelected?._id ? false : true}
                            >
                              Edit User
                            </Button>
                            <Button
                              className="order-12 mb-0 ml-2 orange-btn"
                              variant="warning"
                              onClick={() => {
                                setShowRemoveTokenModal(true);
                              }}
                              disabled={userOptionSelected?._id ? false : true}
                            >
                              Delete Google Token
                            </Button>
                            <Button
                              className="order-12 mb-0 ml-2 green-btn"
                              variant=""
                              onClick={() => {
                                handleDuplicateUser();
                              }}
                              disabled={userOptionSelected?._id ? false : true}
                            >
                              Duplicate User
                            </Button>
                            <Button
                              className="order-13 mb-0 ml-2"
                              variant="danger"
                              onClick={() => {
                                setShowErrorModal(true);
                              }}
                              disabled={userOptionSelected?._id ? false : true}
                            >
                              Delete User
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col className="transperent">
                  <Card>
                    <Card.Body>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "10px",
                          }}
                        >
                          <Form.Label column lg={2} id="smallerFontSize">
                            User Type
                          </Form.Label>
                          <Col lg={9}>
                            <div className="checkboxes">
                              <Form.Check
                                type="radio"
                                name="userType"
                                value="off"
                                onChange={(e) => onChangeUserType("off")}
                                checked={userType === false ? true : false}
                              ></Form.Check>{" "}
                              <Form.Label
                                style={{ marginLeft: "5px" }}
                                column
                                lg={4}
                                id="smallerFontSize"
                              >
                                {" "}
                                Regular{" "}
                              </Form.Label>
                              <Form.Check
                                type="radio"
                                name="userType"
                                value="on"
                                onChange={(e) => onChangeUserType("on")}
                                checked={userType === true ? true : false}
                                style={{ marginLeft: "5px" }}
                              />{" "}
                              <Form.Label
                                style={{ marginLeft: "5px" }}
                                column
                                lg={4}
                                id="smallerFontSize"
                              >
                                {" "}
                                API{" "}
                              </Form.Label>
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "10px",
                          }}
                        >
                          <Form.Label column lg={2} id="smallerFontSize">
                            Require VPN
                          </Form.Label>
                          <Col lg={9}>
                            <div className="toggle-switch">
                              <Form.Check
                                type="switch"
                                id="showHashToggle"
                                onChange={(e) =>
                                  onChangeRequireVPN(
                                    e.target.checked ? "on" : "off"
                                  )
                                }
                                checked={requireVPN}
                              />
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      {userType == true && (
                        <>
                          <Row>
                            <Form.Group
                              as={Row}
                              className="mb-3"
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Form.Label
                                column
                                lg={3}
                                htmlFor="simpleinput"
                                id="smallerFontSize"
                              >
                                Username
                              </Form.Label>
                              <Col lg={3}>
                                <Form.Control
                                  name="username"
                                  type="text"
                                  id="simpleinput"
                                  value={username}
                                  onChange={(e) => {
                                    setUsername(e.target.value);
                                    setUsersSaveDisabled(false);
                                  }}
                                  className={`fsz-875rem ${invalidFields.includes("username") ? "is-invalid" : ""}`}
                                />
                              </Col>
                              <Form.Label
                                column
                                lg={3}
                                htmlFor="simpleinput"
                                id="smallerFontSize"
                              >
                                Password
                              </Form.Label>
                              <Col lg={3}>
                                <InputGroup>
                                  <Form.Control
                                    name="password"
                                    type={
                                      showPassword == true ? "text" : "password"
                                    }
                                    id="simpleinput"
                                    value={password}
                                    onChange={(e) => {
                                      setPassword(e.target.value);
                                      setUsersSaveDisabled(false);
                                    }}
                                    className={`fsz-875rem ${invalidFields.includes("password") ? "is-invalid" : ""}`}
                                  />

                                  <InputGroup.Text
                                    onClick={() => {
                                      setShowPassword(
                                        showPassword == true ? false : true
                                      );
                                    }}
                                  >
                                    <FeatherIcon
                                      icon={
                                        showPassword == true ? "eye-off" : "eye"
                                      }
                                      className="icon-dual"
                                    />
                                  </InputGroup.Text>
                                </InputGroup>
                              </Col>
                            </Form.Group>
                          </Row>
                          <Row>
                            <Form.Group
                              as={Row}
                              className="mb-3"
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Form.Label
                                column
                                lg={3}
                                htmlFor="simpleinput"
                                id="smallerFontSize"
                              >
                                Client ID
                              </Form.Label>
                              <Col lg={3}>
                                <Form.Control
                                  name="clientId"
                                  type="text"
                                  id="simpleinput"
                                  value={clientID}
                                  onChange={(e) => {
                                    setClientID(e.target.value);
                                    setUsersSaveDisabled(false);
                                  }}
                                  className={`fsz-875rem ${invalidFields.includes("clientID") ? "is-invalid" : ""}`}
                                />
                              </Col>
                              <Form.Label
                                column
                                lg={3}
                                htmlFor="simpleinput"
                                id="smallerFontSize"
                              >
                                Client Secret
                              </Form.Label>
                              <Col lg={3}>
                                <InputGroup>
                                  <Form.Control
                                    name="clientSecret"
                                    type={
                                      showSecret == true ? "text" : "password"
                                    }
                                    id="simpleinput"
                                    value={clientSecret}
                                    onChange={(e) => {
                                      setClientSecret(e.target.value);
                                      setUsersSaveDisabled(false);
                                    }}
                                    className={`fsz-875rem ${invalidFields.includes("clientSecret") ? "is-invalid" : ""}`}
                                  />

                                  <InputGroup.Text
                                    onClick={() => {
                                      setShowSecret(
                                        showSecret == true ? false : true
                                      );
                                    }}
                                  >
                                    <FeatherIcon
                                      icon={
                                        showSecret == true ? "eye-off" : "eye"
                                      }
                                      className="icon-dual"
                                    />
                                  </InputGroup.Text>
                                </InputGroup>
                              </Col>
                            </Form.Group>
                          </Row>
                        </>
                      )}
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "10px",
                          }}
                        >
                          <Form.Label column lg={2} id="smallerFontSize">
                            Controlium Type
                          </Form.Label>
                          <Col lg={9}>
                            <div className="checkboxes">
                              <Form.Check
                                type="radio"
                                name="controliumType"
                                value="off"
                                onChange={(e) => onChangeControliumType("off")}
                                checked={
                                  controliumType === false ? true : false
                                }
                              ></Form.Check>{" "}
                              <Form.Label
                                style={{ marginLeft: "5px" }}
                                column
                                lg={4}
                                id="smallerFontSize"
                              >
                                {" "}
                                Regular{" "}
                              </Form.Label>
                              <Form.Check
                                type="radio"
                                name="controliumType"
                                value="on"
                                onChange={(e) => onChangeControliumType("on")}
                                checked={controliumType === true ? true : false}
                                style={{ marginLeft: "5px" }}
                              />{" "}
                              <Form.Label
                                style={{ marginLeft: "5px" }}
                                column
                                lg={4}
                                id="smallerFontSize"
                              >
                                {" "}
                                White Label{" "}
                              </Form.Label>
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            Tenant Name
                          </Form.Label>
                          <Col lg={3}>
                            <Form.Control
                              name="tenantName"
                              type="text"
                              id="simpleinput"
                              value={tenantName}
                              disabled={!controliumType}
                              onChange={(e) => {
                                setTenantName(e.target.value);
                                setUsersSaveDisabled(false);
                              }}
                              className={`fsz-875rem ${invalidFields.includes("tenantName") ? "is-invalid" : ""}`}
                            />
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            Logo Folder Name
                          </Form.Label>
                          <Col lg={3}>
                            <Form.Control
                              name="logoFolder"
                              type="text"
                              id="simpleinput"
                              value={logoFolder}
                              disabled={!controliumType}
                              onChange={(e) => {
                                setLogoFolder(e.target.value);
                                setUsersSaveDisabled(false);
                              }}
                              className={`fsz-875rem ${invalidFields.includes("logoFolder") ? "is-invalid" : ""}`}
                            />
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <Form.Label
                            column
                            lg={2}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                            className="py-0"
                          >
                            Access
                          </Form.Label>

                          <Col
                            lg={10}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              flexWrap: "wrap",
                            }}
                          >
                            {rolesList?.map((obj: any, i: number) => (
                              <>
                                <Form.Group
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: "7px",
                                  }}
                                >
                                  <Form.Check
                                    disabled={
                                      Object.keys(userOptionSelected).length ===
                                      0
                                    }
                                    checked={userAccessRole.find(
                                      (roleId: any) => roleId === obj._id
                                    )}
                                    // style={{ display:"flex",alignItems:"center" }}
                                    onChange={(e) => {
                                      handleChaneUserRole(e, obj._id);
                                      validateAccessRoleReleventValueBox(
                                        e,
                                        obj.role_name
                                      );
                                    }}
                                    name={obj.role_name}
                                    type="checkbox"
                                    id={`screen${i}`}
                                    // label={obj.role_name}
                                  />
                                  <Form.Label
                                    style={{ margin: "0px 15px 0px 5px" }}
                                    id="smallerFontSize"
                                  >
                                    {obj.role_name}
                                  </Form.Label>
                                </Form.Group>
                              </>
                            ))}
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Form.Label
                            column
                            lg={2}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            IP Restriction
                          </Form.Label>
                          <Col lg={4}>
                            <Form.Control
                              type="text"
                              id="simpleinput"
                              value={userIPRestrictionFrom}
                              onChange={(e) => {
                                setUserIPRestrictionFrom(e.target.value);
                                validateIPAddress(
                                  e.target.value,
                                  setUserIPRestrictionFromErr
                                );
                              }}
                              className="fsz-875rem"
                              placeholder="From..."
                            />
                            {userIPRestrictionFromErr && (
                              <span
                                style={{
                                  color: "#dc3545",
                                  fontFamily: "Silka",
                                  fontSize: 12,
                                }}
                              >
                                {" "}
                                Please use IPv4 address format (X.X.X.X){" "}
                              </span>
                            )}
                          </Col>
                          <Col lg={4}>
                            <Form.Control
                              type="text"
                              id="simpleinput"
                              value={userIPRestrictionTo}
                              onChange={(e) => {
                                setUserIPRestrictionTo(e.target.value);
                                validateIPAddress(
                                  e.target.value,
                                  setUserIPRestrictionToErr
                                );
                              }}
                              className="fsz-875rem"
                              placeholder="To..."
                            />
                            {userIPRestrictionToErr && (
                              <span
                                style={{
                                  color: "#dc3545",
                                  fontFamily: "Silka",
                                  fontSize: 12,
                                }}
                              >
                                Please use IPv4 address format (X.X.X.X)
                              </span>
                            )}
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "10px",
                          }}
                        >
                          <Form.Label column lg={2} id="smallerFontSize">
                            Show Hash/Unhash Button
                          </Form.Label>
                          <Col lg={9}>
                            <div className="toggle-switch">
                              <Form.Check
                                type="switch"
                                id="showHashToggle"
                                onChange={(e) =>
                                  onChangeShowHash(
                                    e.target.checked ? "on" : "off"
                                  )
                                }
                                checked={showHash}
                              />
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col lg={6} className="mb-3">
                  <Card className="h-100">
                    <Card.Body>
                      <Row>
                        <h4
                          style={{
                            fontSize: "15px",
                            margin: "0 0 7px",
                            fontWeight: "600",
                            textTransform: "uppercase",
                          }}
                        >
                          Campaigns
                        </h4>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label
                            column
                            lg={2}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            Campaign Type
                          </Form.Label>
                          <Col
                            lg={10}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              flexWrap: "wrap",
                            }}
                          >
                            <Col xs="auto" style={{ display: "flex" }}>
                              <Form.Check
                                type="checkbox"
                                name="cjsc_id"
                                checked={cjscFormik.values.cjsc_id}
                                onChange={cjscFormik.handleChange}
                                onBlur={cjscFormik.handleBlur}
                              />
                              <Form.Label
                                style={{ margin: "0px 15px 0px 5px" }}
                                id="smallerFontSize"
                              >
                                User ID
                              </Form.Label>
                            </Col>
                            <Col xs="auto" style={{ display: "flex" }}>
                              <Form.Check
                                type="checkbox"
                                name="cjsc_ip"
                                checked={cjscFormik.values.cjsc_ip}
                                onChange={cjscFormik.handleChange}
                                onBlur={cjscFormik.handleBlur}
                              />
                              <Form.Label
                                style={{ margin: "0px 15px 0px 5px" }}
                                id="smallerFontSize"
                              >
                                IP Address
                              </Form.Label>
                            </Col>
                            <Col xs="auto" style={{ display: "flex" }}>
                              <Form.Check
                                type="checkbox"
                                name="cjsc_id_ip"
                                checked={cjscFormik.values.cjsc_id_ip}
                                onChange={cjscFormik.handleChange}
                                onBlur={cjscFormik.handleBlur}
                              />
                              <Form.Label
                                style={{ margin: "0px 15px 0px 5px" }}
                                id="smallerFontSize"
                              >
                                User ID + IP Address
                              </Form.Label>
                            </Col>
                            <Col xs="auto" style={{ display: "flex" }}>
                              <Form.Check
                                type="checkbox"
                                name="cjsc_ip_without_id"
                                checked={cjscFormik.values.cjsc_ip_without_id}
                                onChange={cjscFormik.handleChange}
                                onBlur={cjscFormik.handleBlur}
                              />
                              <Form.Label
                                style={{ margin: "0px 15px 0px 5px" }}
                                id="smallerFontSize"
                              >
                                IP without USER ID
                              </Form.Label>
                            </Col>
                            <Col xs="auto" style={{ display: "flex" }}>
                              <Form.Check
                                id="checkbox-fifo"
                                type="checkbox"
                                name="cjsc_fifo"
                                checked={cjscFormik.values.cjsc_fifo}
                                onChange={cjscFormik.handleChange}
                                onBlur={cjscFormik.handleBlur}
                              />
                              <Form.Label
                                style={{ margin: "0px 15px 0px 5px" }}
                                id="smallerFontSize"
                                htmlFor="checkbox-fifo"
                              >
                                FIFO
                              </Form.Label>
                            </Col>
                            <Col xs="auto" style={{ display: "flex" }}>
                              <Form.Check
                                id="checkbox-fifo"
                                type="checkbox"
                                name="cjsc_multi_ipid"
                                checked={cjscFormik.values.cjsc_multi_ipid}
                                onChange={cjscFormik.handleChange}
                                onBlur={cjscFormik.handleBlur}
                              />
                              <Form.Label
                                style={{ margin: "0px 15px 0px 5px" }}
                                id="smallerFontSize"
                                htmlFor="checkbox-fifo"
                              >
                                Multi Ad URL With User ID
                              </Form.Label>
                            </Col>
                            <Col xs="auto" style={{ display: "flex" }}>
                              <Form.Check
                                id="checkbox-fifo"
                                type="checkbox"
                                name="cjsc_multi_ipnoid"
                                checked={cjscFormik.values.cjsc_multi_ipnoid}
                                onChange={cjscFormik.handleChange}
                                onBlur={cjscFormik.handleBlur}
                              />
                              <Form.Label
                                style={{ margin: "0px 15px 0px 5px" }}
                                id="smallerFontSize"
                                htmlFor="checkbox-fifo"
                              >
                                Multi Ad URL Without User ID
                              </Form.Label>
                            </Col>
                            <Col xs="auto" style={{ display: "flex" }}>
                              <Form.Check
                                id="checkbox-fifo"
                                type="checkbox"
                                name="cjsc_infinite_fifo"
                                checked={cjscFormik.values.cjsc_infinite_fifo}
                                onChange={cjscFormik.handleChange}
                                onBlur={cjscFormik.handleBlur}
                              />
                              <Form.Label
                                style={{ margin: "0px 15px 0px 5px" }}
                                id="smallerFontSize"
                                htmlFor="checkbox-fifo"
                              >
                                Infinite FIFO
                              </Form.Label>
                            </Col>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row style={{ marginBottom: "10px" }}>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label
                            column
                            lg={2}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            URL Type
                          </Form.Label>
                          <Col
                            lg={10}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              flexWrap: "wrap",
                            }}
                          >
                            <Col xs="auto" style={{ display: "flex" }}>
                              <Form.Check
                                type="checkbox"
                                name="cjsc_script"
                                checked={cjscFormik.values.cjsc_script}
                                onChange={cjscFormik.handleChange}
                                onBlur={cjscFormik.handleBlur}
                              />
                              <Form.Label
                                style={{ margin: "0px 15px 0px 5px" }}
                                id="smallerFontSize"
                              >
                                Script
                              </Form.Label>
                            </Col>
                            <Col xs="auto" style={{ display: "flex" }}>
                              <Form.Check
                                type="checkbox"
                                name="cjsc_user_agent"
                                checked={cjscFormik.values.cjsc_user_agent}
                                onChange={cjscFormik.handleChange}
                                onBlur={cjscFormik.handleBlur}
                              />

                              <Form.Label
                                style={{ margin: "0px 15px 0px 5px" }}
                                id="smallerFontSize"
                              >
                                User Agent
                              </Form.Label>
                            </Col>
                            <Col xs="auto" style={{ display: "flex" }}>
                              <Form.Check
                                type="checkbox"
                                name="panda"
                                checked={cjscFormik.values.panda}
                                onChange={cjscFormik.handleChange}
                                onBlur={cjscFormik.handleBlur}
                              />
                              <Form.Label
                                style={{ margin: "0px 15px 0px 5px" }}
                                id="smallerFontSize"
                              >
                                De-anon
                              </Form.Label>
                            </Col>
                            <Col xs="auto" style={{ display: "flex" }}>
                              <Form.Check
                                type="checkbox"
                                name="monitor"
                                checked={cjscFormik.values.monitor}
                                onChange={cjscFormik.handleChange}
                                onBlur={cjscFormik.handleBlur}
                              />
                              <Form.Label
                                style={{ margin: "0px 15px 0px 5px" }}
                                id="smallerFontSize"
                              >
                                Monitor
                              </Form.Label>
                            </Col>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            Campaigns IDs
                          </Form.Label>
                          <Col lg={9}>
                          <Select
                            isMulti={true}
                            options={cJscIdDropdownList.map((option: any) => ({
                              ...option,
                              isDisabled: false,
                            }))}
                            className="react-select react-select-container"
                            classNamePrefix="react-select"
                            components={{
                              MultiValueRemove,
                              MultiValueLabel
                            }}
                            styles={{
                              multiValue: (base, { data }) => ({
                                ...base,
                                backgroundColor:
                                  data.value === userOptionSelected._id ? '#e0e0e0' : base.backgroundColor,
                                color:
                                  data.value === userOptionSelected._id ? '#666' : base.color,
                              }),
                            }}
                            onChange={(selectedOptions) => {
                              const alwaysIncludedOption = cJscIdDropdownList.find(
                                (option: any) => option.value === userOptionSelected._id
                              );

                              const updatedOptions = [
                                alwaysIncludedOption,
                                ...selectedOptions.filter(
                                  (option) => option.value !== userOptionSelected._id
                                ),
                              ];
                              setCJscId(updatedOptions);
                              setUsersSaveDisabled(false);
                            }}
                            value={[
                              cJscIdDropdownList.find((option: any) => option.value === userOptionSelected._id),
                              ...cJscId.filter((option: any) => option.value !== userOptionSelected._id),
                            ]}
                            maxMenuHeight={100}
                          />
                            {isValidateCJSCIds && cJscId.length === 0 && (
                              <span
                                style={{
                                  color: "#dc3545",
                                  fontFamily: "Silka",
                                  fontSize: 12,
                                }}
                              >
                                Please select
                              </span>
                            )}
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={3} id="smallerFontSize">
                            Allow Pause
                          </Form.Label>
                          <Col lg={9}>
                            <div className="toggle-switch">
                              <Form.Check
                                type="switch"
                                id="allowPause"
                                onChange={(e) =>
                                  onChangeAllowPause(
                                    e.target.checked ? "on" : "off"
                                  )
                                }
                                checked={allowPause}
                              />
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={3} id="smallerFontSize">
                            Allow Edit
                          </Form.Label>
                          <Col lg={9}>
                            <div className="toggle-switch">
                              <Form.Check
                                type="switch"
                                id="allowEdit"
                                onChange={(e) =>
                                  onChangeAllowEdit(
                                    e.target.checked ? "on" : "off"
                                  )
                                }
                                checked={allowEdit}
                              />
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={3} id="smallerFontSize">
                            Truncated IPs
                          </Form.Label>
                          <Col lg={9}>
                            <div className="toggle-switch">
                              <Form.Check
                                type="switch"
                                id="truncatedIPsToggle"
                                onChange={(e) =>
                                  onChangeTruncatedIPs(
                                    e.target.checked ? "on" : "off"
                                  )
                                }
                                checked={truncatedIPs}
                              />
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={3} id="smallerFontSize">
                            Multi Campaign
                          </Form.Label>
                          <Col lg={9}>
                            <div className="toggle-switch">
                              <Form.Check
                                type="switch"
                                id="multiCampaignToggle"
                                onChange={(e) =>
                                  onChangeMultiCampaign(
                                    e.target.checked ? "on" : "off"
                                  )
                                }
                                checked={multiCampaign}
                              />
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={3} id="smallerFontSize">
                            User ID Cooldown
                          </Form.Label>
                          <Col lg={9}>
                            <div className="toggle-switch">
                              <Form.Check
                                type="switch"
                                id="CooldownToggle"
                                onChange={(e) =>
                                  onChangeCooldown(
                                    e.target.checked ? "on" : "off"
                                  )
                                }
                                checked={cooldown}
                              />
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      
                      <Row>
                        <Form.Group
                          name="cooldownInput"
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            id="smallerFontSize"
                            style={{
                              color:
                                !cooldown
                                  ? "gray"
                                  : "#4b4b5a",
                            }}
                          >
                            User ID Cooldown Time (In Hours)
                      
                          </Form.Label>
                          <Col lg={5}>
                            <Form.Control
                              disabled={
                                cooldown === false
                              }
                              type="number"
                              id="simpleinput"
                              min={0}
                              value={cooldownTime}
                              onChange={(e) => {
                                setCooldownTime(parseInt(e.target.value));
                                setUsersSaveDisabled(false);
                              }}
                              className={`fsz-875rem ${invalidFields.includes("cooldownTime") ? "is-invalid" : ""}`}
                              style={{
                                padding: "4px",
                                color: "#4b4b5a",
                                fontSize: ".875rem !important",
                                //width: "40px",
                                textAlign: "left",
                              }}
                            />
                          </Col>
                        </Form.Group>
                      </Row>

                       <hr></hr>       
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={3} id="smallerFontSize">
                            Augmentor
                          </Form.Label>
                          <Col lg={9}>
                            <div className="toggle-switch">
                              <Form.Check
                                type="switch"
                                id="augmentorToggle"
                                onChange={(e) =>
                                  onChangeAugmentor(
                                    e.target.checked ? "on" : "off"
                                  )
                                }
                                checked={augmentor}
                              />
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            id="smallerFontSize"
                            style={{ color: augmentor ? "#4b4b5a" : "grey" }}
                          >
                            Augmentor OpSec
                          </Form.Label>
                          <Col lg={9}>
                            <div className="toggle-switch">
                              <Form.Check
                                type="switch"
                                id="augmentorOpSecToggle"
                                onChange={(e) =>
                                  onChangeAugmentorOpSec(
                                    e.target.checked ? "on" : "off"
                                  )
                                }
                                checked={augmentorOpSec}
                                disabled={!augmentor}
                              />
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            id="smallerFontSize"
                            style={{
                              color:
                                !augmentorOpSec || !augmentor
                                  ? "gray"
                                  : "#4b4b5a",
                            }}
                          >
                            OpSec Type
                          </Form.Label>
                          <Col lg={9}>
                            <div className="checkboxes">
                              <Form.Check
                                type="radio"
                                disabled={
                                  augmentorOpSec === false ||
                                  augmentor === false
                                }
                                name="opSecType"
                                value="off"
                                onChange={(e) => onChangeOpSecType("off")}
                                checked={opSecType === false ? true : false}
                              ></Form.Check>{" "}
                              <Form.Label
                                style={{
                                  marginLeft: "5px",
                                  color:
                                    !augmentorOpSec || !augmentor
                                      ? "gray"
                                      : "#4b4b5a",
                                }}
                                column
                                lg={3}
                                id="smallerFontSize"
                              >
                                {" "}
                                Timer Only{" "}
                              </Form.Label>
                              <Form.Check
                                type="radio"
                                name="opSecType"
                                value="on"
                                onChange={(e) => onChangeOpSecType("on")}
                                checked={opSecType === true ? true : false}
                                style={{ marginLeft: "5px" }}
                                disabled={
                                  augmentorOpSec === false ||
                                  augmentor === false
                                }
                              />{" "}
                              <Form.Label
                                style={{
                                  marginLeft: "5px",
                                  color:
                                    !augmentorOpSec || !augmentor
                                      ? "gray"
                                      : "#4b4b5a",
                                }}
                                column
                                lg={3}
                                id="smallerFontSize"
                              >
                                {" "}
                                Timer + IP{" "}
                              </Form.Label>
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          name="maxAmountInput"
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            id="smallerFontSize"
                            style={{
                              color:
                                !augmentorOpSec || !augmentor
                                  ? "gray"
                                  : "#4b4b5a",
                            }}
                          >
                            OpSec Bid Timer (In Seconds)
                          </Form.Label>
                          <Col lg={5}>
                            <Form.Control
                              disabled={
                                augmentorOpSec === false || augmentor === false
                              }
                              type="number"
                              id="simpleinput"
                              min={0}
                              value={opSecBidTimer}
                              onChange={(e) => {
                                setOpSecBidTimer(parseInt(e.target.value));
                                setUsersSaveDisabled(false);
                              }}
                              className={`fsz-875rem ${invalidFields.includes("opSecBidTimer") ? "is-invalid" : ""}`}
                              style={{
                                padding: "4px",
                                color: "#4b4b5a",
                                fontSize: ".875rem !important",
                                //width: "40px",
                                textAlign: "left",
                              }}
                            />
                          </Col>
                        </Form.Group>
                      </Row>
                      <hr></hr>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={3} id="smallerFontSize">
                            Bid OpSec
                          </Form.Label>
                          <Col lg={9}>
                            <div className="toggle-switch">
                              <Form.Check
                                type="switch"
                                id="bidOpSecToggle"
                                onChange={(e) =>
                                  onChangeBidOpSec(
                                    e.target.checked ? "on" : "off"
                                  )
                                }
                                checked={bidOpSec}
                              />
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            id="smallerFontSize"
                            style={{ color: bidOpSec ? "#4b4b5a" : "grey" }}
                          >
                            Mandatory
                          </Form.Label>
                          <Col lg={9}>
                            <div className="toggle-switch">
                              <Form.Check
                                type="switch"
                                id="mandatoryToggle"
                                onChange={(e) =>
                                  onChangeMandatory(
                                    e.target.checked ? "on" : "off"
                                  )
                                }
                                checked={mandatory}
                                disabled={!bidOpSec}
                              />
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={3} id="smallerFontSize">
                            By Auction ID
                          </Form.Label>
                          <Col lg={9}>
                            <div className="toggle-switch">
                              <Form.Check
                                type="switch"
                                id="byAuctionIdToggle"
                                onChange={(e) =>
                                  onChangeByAuctionId(
                                    e.target.checked ? "on" : "off"
                                  )
                                }
                                checked={byAuctionId}
                                disabled={!bidOpSec}
                              />
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            id="smallerFontSize"
                            style={{ color: bidOpSec ? "#4b4b5a" : "grey" }}
                          >
                            By Bid Time
                          </Form.Label>
                          <Col lg={9}>
                            <div className="toggle-switch">
                              <Form.Check
                                type="switch"
                                id="byBidTimeToggle"
                                onChange={(e) =>
                                  onChangeByBidTime(
                                    e.target.checked ? "on" : "off"
                                  )
                                }
                                checked={byBidTime}
                                disabled={!bidOpSec}
                              />
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          name="maxAmountInput"
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            id="smallerFontSize"
                            style={{
                              color:
                                !byBidTime || !bidOpSec
                                  ? "gray"
                                  : "#4b4b5a",
                            }}
                          >
                            OpSec Bid Timer (In Seconds)
                          </Form.Label>
                          <Col lg={5}>
                            <Form.Control
                              disabled={
                                byBidTime === false || bidOpSec === false
                              }
                              type="number"
                              id="simpleinput"
                              min={0}
                              max={10000}
                              value={bidOpSecTime}
                              onChange={(e) => {
                                setBidOpSecTime(parseInt(e.target.value));
                                setUsersSaveDisabled(false);
                              }}
                              className={`fsz-875rem ${invalidFields.includes("bidOpSecTime") ? "is-invalid" : ""}`}
                              style={{
                                padding: "4px",
                                color: "#4b4b5a",
                                fontSize: ".875rem !important",
                                //width: "40px",
                                textAlign: "left",
                              }}
                            />
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          name="maxAmountInput"
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            id="smallerFontSize"
                            style={{
                              color:
                                !byBidTime || !bidOpSec
                                  ? "gray"
                                  : "#4b4b5a",
                            }}
                          >
                            Bid Time Offset (In Seconds)
                          </Form.Label>
                          <Col lg={5}>
                            <Form.Control
                              disabled={
                                byBidTime === false || bidOpSec === false
                              }
                              type="number"
                              id="simpleinput"
                              min={0}
                              max={10000}
                              value={bidOpSecOffset}
                              onChange={(e) => {
                                setBidOpSecOffset(parseInt(e.target.value));
                                setUsersSaveDisabled(false);
                              }}
                              className={`fsz-875rem ${invalidFields.includes("bidOpSecOffset") ? "is-invalid" : ""}`}
                              style={{
                                padding: "4px",
                                color: "#4b4b5a",
                                fontSize: ".875rem !important",
                                //width: "40px",
                                textAlign: "left",
                              }}
                            />
                          </Col>
                        </Form.Group>
                      </Row>
                      <hr></hr>  
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={3} id="smallerFontSize">
                            Auto Filtering
                          </Form.Label>
                          <Col lg={9}>
                            <div className="toggle-switch">
                              <Form.Check
                                type="switch"
                                id="autoIpToggle"
                                onChange={(e) =>
                                  onChangeAutoIP(
                                    e.target.checked ? "on" : "off"
                                  )
                                }
                                checked={autoIp}
                              />
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={3} id="smallerFontSize">
                            Prefilter
                          </Form.Label>
                          <Col lg={9}>
                            <div className="toggle-switch">
                              <Form.Check
                                type="switch"
                                id="prefilter"
                                onChange={(e) =>
                                  onChangePrefilter(
                                    e.target.checked ? "on" : "off"
                                  )
                                }
                                checked={prefilter}
                              />
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          name="maxAmountInput"
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            id="smallerFontSize"
                            style={{ color: !prefilter ? "gray" : "#4b4b5a" }}
                          >
                            Prefilter Source IP
                          </Form.Label>
                          <Col lg={4}>
                            <Form.Control
                              disabled={!prefilter}
                              type="text"
                              id="simpleinput"
                              value={prefilterIP}
                              onChange={(e) => {
                                setPrefilterIP(e.target.value);
                                // setUsersSaveDisabled(false);
                                validateIPAddress(
                                  e.target.value,
                                  setPrefilterIPErr
                                );
                              }}
                              className={`fsz-875rem ${invalidFields.includes("prefilterIP") ? "is-invalid" : ""}`}
                            />
                            {prefilterIPErr && (
                              <span
                                style={{
                                  color: "#dc3545",
                                  fontFamily: "Silka",
                                  fontSize: 12,
                                }}
                              >
                                Please use IPv4 address format (X.X.X.X)
                              </span>
                            )}
                          </Col>
                          <Form.Label
                            column
                            lg={3}
                            id="smallerFontSize"
                            style={{ color: !prefilter ? "gray" : "#4b4b5a" }}
                          >
                            Destination Port
                          </Form.Label>
                          <Col lg={4}>
                            <Form.Control
                              disabled={!prefilter}
                              type="number"
                              id="simpleinput"
                              value={destPort}
                              onChange={(e) => {
                                setDestPort(e.target.value);
                                setUsersSaveDisabled(false);
                              }}
                              className={`fsz-875rem ${invalidFields.includes("destPort") ? "is-invalid" : ""}`}
                            />
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={3} id="smallerFontSize">
                            Ad URL Type
                          </Form.Label>
                          <Col lg={9}>
                            <div className="checkboxes">
                              <Form.Check
                                type="radio"
                                name="adUrlType"
                                value="off"
                                onChange={(e) => onChangeAdUrlType("off")}
                                checked={adUrlType === false ? true : false}
                              ></Form.Check>{" "}
                              <Form.Label
                                style={{ marginLeft: "5px" }}
                                column
                                lg={4}
                                id="smallerFontSize"
                              >
                                {" "}
                                Regular{" "}
                              </Form.Label>
                              <Form.Check
                                type="radio"
                                name="adUrlType"
                                value="on"
                                onChange={(e) => onChangeAdUrlType("on")}
                                checked={adUrlType === true ? true : false}
                                style={{ marginLeft: "5px" }}
                              />{" "}
                              <Form.Label
                                style={{ marginLeft: "5px" }}
                                column
                                lg={4}
                                id="smallerFontSize"
                              >
                                {" "}
                                Hashed{" "}
                              </Form.Label>
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={3} id="smallerFontSize">
                            Frequency Cap
                          </Form.Label>
                          <Col lg={9}>
                            <div className="toggle-switch">
                              <Form.Check
                                type="switch"
                                id="freq_cap_toggle"
                                onChange={(e) =>
                                  cjscFormik.setFieldValue(
                                    "freq_cap",
                                    e.target.checked
                                  )
                                }
                                checked={cjscFormik.values.freq_cap}
                              />
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group as={Row} className="mb-0 mt-3">
                          <Form.Label column lg={3} id="smallerFontSize">
                            Ad URL OpSec
                          </Form.Label>
                          <Col lg={9}>
                            <div style={{ display: "flex", gap: "15px" }}>
                              {[
                                { value: "off", label: "Off" },
                                { value: "ip", label: "IP Only" },
                                { value: "adv", label: "Advanced User Info" },
                                { value: "v2", label: "V2" },
                              ].map((option) => (
                                <Form.Check
                                  key={option.value}
                                  type="radio"
                                  id={`concat_ip_${option.value}`}
                                  name="concat_ip"
                                  label={option.label}
                                  value={option.value}
                                  onChange={(e) => {
                                    cjscFormik.setFieldValue("concat_ip", e.target.value);
                                    if (e.target.value !== "v2") {
                                      cjscFormik.setFieldValue("disrupt_opsec_v2", false);
                                    }
                                  }}
                                  checked={cjscFormik.values.concat_ip === option.value}
                                />
                              ))}
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row className="align-items-center mt-2">
                        <Col lg={3} className="text-end pe-2">
                          <Form.Label id="smallerFontSize" className="mb-0">
                            &nbsp;
                          </Form.Label>
                        </Col>
                        <Col lg={9} className="d-flex align-items-center gap-2">
                          <Form.Check
                            id="checkbox-disrupt"
                            type="checkbox"
                            name="disrupt_opsec"
                            checked={cjscFormik.values.disrupt_opsec_v2 === true}
                            onChange={(e) => cjscFormik.setFieldValue("disrupt_opsec_v2", e.target.checked)}
                            onBlur={cjscFormik.handleBlur}
                            disabled={cjscFormik.values.concat_ip !== "v2"}
                          />
                          <Form.Label
                            className="mb-0"
                            style={{
                              color: cjscFormik.values.concat_ip !== "v2" ? "gray" : "#4b4b5a",
                            }}
                            htmlFor="checkbox-disrupt"
                          >
                            Disrupt OpSec V2 Values
                          </Form.Label>
                        </Col>
                    </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={3} id="smallerFontSize">
                            Ad URL OpSec Key
                          </Form.Label>
                          <Col lg={4}>
                            <Form.Control
                              disabled={cjscFormik.values.concat_ip !== "v2"}
                              type="text"
                              id="simpleinput"
                              value={cjscFormik.values.opsec_key}
                              onChange={(e) =>
                                cjscFormik.setFieldValue(
                                  "opsec_key",
                                  e.target.value
                                )
                              }
                              className={`fsz-875rem ${invalidFields.includes("opsec_key") ? "is-invalid" : ""}`}
                            />
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            id="smallerFontSize"
                            style={{ color: !adUrlType ? "gray" : "#4b4b5a" }}
                          >
                            Log Connections
                          </Form.Label>
                          <Col lg={9}>
                            <div className="toggle-switch">
                              <Form.Check
                                type="switch"
                                id="logConnToggle"
                                disabled={adUrlType !== true}
                                onChange={(e) =>
                                  onChangeLogConn(
                                    e.target.checked ? "on" : "off"
                                  )
                                }
                                checked={logConn === true}
                              />
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            Callback Type
                          </Form.Label>
                          <Col lg={10}>
                            <div className="checkboxes">
                              <Form.Check
                                type="radio"
                                name="callbackType"
                                value="off"
                                checked={
                                  cjscCallbackType === "off" ? true : false
                                }
                                onChange={(e) =>
                                  handleCallbackTypeSelection("off")
                                }
                              ></Form.Check>{" "}
                              <Form.Label
                                style={{ marginLeft: "5px" }}
                                column
                                lg={2}
                                id="smallerFontSize"
                              >
                                {" "}
                                Off{" "}
                              </Form.Label>
                              <Form.Check
                                type="radio"
                                name="callbackType"
                                value="event_logger"
                                checked={
                                  cjscCallbackType === "event_logger"
                                    ? true
                                    : false
                                }
                                style={{ marginLeft: "5px" }}
                                onChange={(e) =>
                                  handleCallbackTypeSelection("event_logger")
                                }
                              />{" "}
                              <Form.Label
                                style={{ marginLeft: "5px" }}
                                column
                                lg={4}
                                id="smallerFontSize"
                              >
                                {" "}
                                Events Logger{" "}
                              </Form.Label>
                              <Form.Check
                                type="radio"
                                name="callbackType"
                                value="url"
                                checked={
                                  cjscCallbackType === "url" ? true : false
                                }
                                style={{ marginLeft: "5px" }}
                                onChange={(e) =>
                                  handleCallbackTypeSelection("url")
                                }
                              />{" "}
                              <Form.Label
                                style={{ marginLeft: "5px" }}
                                column
                                lg={2}
                                id="smallerFontSize"
                              >
                                {" "}
                                URL{" "}
                              </Form.Label>
                              <Form.Check
                                type="radio"
                                name="callbackType"
                                value="api"
                                checked={
                                  cjscCallbackType === "api" ? true : false
                                }
                                style={{ marginLeft: "5px" }}
                                onChange={(e) =>
                                  handleCallbackTypeSelection("api")
                                }
                              />{" "}
                              <Form.Label
                                style={{ marginLeft: "5px" }}
                                column
                                lg={2}
                                id="smallerFontSize"
                              >
                                {" "}
                                API{" "}
                              </Form.Label>
                              <Form.Check
                                type="radio"
                                name="callbackType"
                                value="api_and_logger"
                                checked={
                                  cjscCallbackType === "api_and_logger"
                                    ? true
                                    : false
                                }
                                style={{ marginLeft: "5px" }}
                                onChange={(e) =>
                                  handleCallbackTypeSelection("api_and_logger")
                                }
                              />{" "}
                              <Form.Label
                                style={{ marginLeft: "5px" }}
                                column
                                lg={4}
                                id="smallerFontSize"
                              >
                                {" "}
                                API + Event Logger{" "}
                              </Form.Label>
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            Callback URL
                          </Form.Label>
                          <Col lg={9}>
                            <Form.Control
                              type="text"
                              id="simpleinput"
                              value={cJscCallbackURL}
                              onChange={(e) => {
                                setCJscCallbackURL(e.target.value);
                                if (e.target.value) {
                                  if (validateURL(e.target.value)) {
                                    setUsersSaveDisabled(false);
                                    setCJscCallbackError(false);
                                  } else {
                                    setCJscCallbackError(true);
                                    setUsersSaveDisabled(true);
                                  }
                                } else {
                                  setCJscCallbackError(false);
                                }
                              }}
                              className="fsz-875rem"
                              disabled={
                                cjscCallbackType &&
                                [
                                  "off",
                                  "event_logger",
                                  "api",
                                  "api_and_logger",
                                ].includes(cjscCallbackType)
                                  ? true
                                  : false
                              }
                            />
                            {cJscCallbackError && (
                              <span
                                style={{
                                  color: "#dc3545",
                                  fontFamily: "Silka",
                                  fontSize: 12,
                                }}
                              >
                                Enter correct url!
                              </span>
                            )}
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            AD URL Whitelist <p>Separated by commas</p>
                          </Form.Label>
                          <Col lg={9}>
                            <Form.Control
                              //type="text"
                              id="simpleinput"
                              value={cJscURLWhiteList}
                              onChange={(e) => {
                                setCJscURLWhiteList(e.target.value);
                                setUsersSaveDisabled(false);
                              }}
                              className="fsz-875rem"
                              as="textarea"
                              rows={5}
                            />
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={3} id="smallerFontSize">
                            Ignore HTTP
                          </Form.Label>
                          <Col lg={9}>
                            <div className="toggle-switch">
                              <Form.Check
                                type="switch"
                                id="ignoreHttpToggle"
                                onChange={(e) =>
                                  onChangeIgnoreHttp(
                                    e.target.checked ? "on" : "off"
                                  )
                                }
                                checked={ignoreHttp === true}
                              />
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={3} id="smallerFontSize">
                            Ignore HTTP : Show in New Campaign
                          </Form.Label>
                          <Col lg={9}>
                            <div className="toggle-switch">
                              <Form.Check
                                type="switch"
                                id="showCjscIgnoreHttpToggle"
                                onChange={(e) =>
                                  onChangeShowCjscIgnoreHttp(
                                    e.target.checked ? "on" : "off"
                                  )
                                }
                                checked={showCjscIgnoreHttp === true}
                              />
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={3} id="smallerFontSize">
                            Limit Amount of Campaigns
                          </Form.Label>
                          <Col lg={9}>
                            <div className="toggle-switch">
                              <Form.Check
                                type="switch"
                                id="campLimitToggle"
                                onChange={(e) =>
                                  onChangeTargetLogger(
                                    e.target.checked ? "on" : "off"
                                  )
                                }
                                checked={cjscLimit === true}
                              />
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>

                      <Row>
                        <Form.Group
                          name="maxAmountInput"
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={3} id="smallerFontSize">
                            Max amount of Campaigns
                          </Form.Label>
                          <Col
                            lg={2}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginTop: "15px",
                            }}
                          >
                            <p>Per Day:</p>
                          </Col>
                          <Col lg={2}>
                            <Form.Control
                              disabled={!cjscLimit}
                              type="number"
                              id="simpleinput"
                              value={maxCampPerDay}
                              onChange={(e) => {
                                setMaxCampPerDay(parseInt(e.target.value));
                                setUsersSaveDisabled(false);
                              }}
                              className={`fsz-875rem ${invalidFields.includes("maxCampPerDay") ? "is-invalid" : ""}`}
                              style={{
                                padding: "4px",
                                color: "#4b4b5a",
                                fontSize: ".875rem !important",
                                width: "40px",
                                textAlign: "left",
                              }}
                            />
                          </Col>
                          <Col
                            lg={2}
                            style={{
                              display: "flex",
                              alignItems: "left",
                              marginTop: "15px",
                              marginLeft: "10px",
                            }}
                          >
                            <p>Per Month:</p>
                          </Col>
                          <Col lg={1}>
                            <Form.Control
                              type="number"
                              id="simpleinput"
                              disabled={!cjscLimit}
                              value={maxCampPerMonth}
                              onChange={(e) => {
                                setMaxCampPerMonth(parseInt(e.target.value));
                                setUsersSaveDisabled(false);
                              }}
                              className={`fsz-875rem ${invalidFields.includes("maxCampPerMonth") ? "is-invalid" : ""}`}
                              style={{
                                padding: "4px",
                                color: "#4b4b5a",
                                fontSize: ".875rem !important",
                                width: "50px",
                                textAlign: "left",
                              }}
                            />
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            Domains Whitelist
                          </Form.Label>
                          <Col lg={9}>
                            <input
                              ref={domainWhitelistUploadRef}
                              style={{ display: "none" }}
                              type="file"
                              onChange={handleDomainWhitelistUpload}
                            />
                            <Row>
                              <Col lg={4}>
                                <Button
                                  variant="primary"
                                  disabled={
                                    userOptionSelected?.name ? false : true
                                  }
                                  onClick={handleUploadDomainCSV}
                                >
                                  Upload New CSV
                                </Button>
                              </Col>
                              <Col lg={4}>
                                <Button
                                  variant="secondary"
                                  disabled={
                                    userOptionSelected?.name ? false : true
                                  }
                                  className="btn btn-info"
                                  onClick={() =>
                                    dispatch(
                                      getDomainWhiteListCSV(
                                        userOptionSelected._id
                                      )
                                    )
                                  }
                                >
                                  Download Existing
                                </Button>
                              </Col>
                              <Col lg={4}>
                                <Button
                                  variant="secondary"
                                  disabled={
                                    userOptionSelected?.name ? false : true
                                  }
                                  className="btn btn-danger"
                                  onClick={() => {
                                    setDeleteWhiteListType("domain");
                                    setShowDeleteWhiteList(true);
                                  }}
                                >
                                  Delete whitelist
                                </Button>
                              </Col>
                            </Row>
                          </Col>
                        </Form.Group>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            Apps Whitelist
                          </Form.Label>
                          <Col lg={9}>
                            <input
                              ref={domainAppUploadRef}
                              style={{ display: "none" }}
                              type="file"
                              onChange={handleAppWhitelistUpload}
                            />
                            <Row>
                              <Col lg={4}>
                                <Button
                                  variant="primary"
                                  disabled={
                                    userOptionSelected?.name ? false : true
                                  }
                                  onClick={handleUploadAppCSV}
                                >
                                  Upload New CSV
                                </Button>
                              </Col>
                              <Col lg={4}>
                                <Button
                                  variant="secondary"
                                  disabled={
                                    userOptionSelected?.name ? false : true
                                  }
                                  className="btn btn-info"
                                  onClick={() =>
                                    dispatch(
                                      getAppWhiteListCSV(userOptionSelected._id)
                                    )
                                  }
                                >
                                  Download Existing
                                </Button>
                              </Col>
                              <Col lg={4}>
                                <Button
                                  variant="secondary"
                                  disabled={
                                    userOptionSelected?.name ? false : true
                                  }
                                  className="btn btn-danger"
                                  onClick={() => {
                                    setDeleteWhiteListType("app");
                                    setShowDeleteWhiteList(true);
                                  }}
                                >
                                  Delete whitelist
                                </Button>
                              </Col>
                            </Row>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={3} id="smallerFontSize">
                            Countries WL/BL
                          </Form.Label>
                          <Col lg={9}>
                            <div className="checkboxes">
                              <Form.Check
                                type="radio"
                                name="countriesType"
                                value="wl"
                                onChange={(e) => {
                                  setCountriesType("wl");
                                  setUsersSaveDisabled(false);
                                }}
                                checked={countriesType == "wl" ? true : false}
                              ></Form.Check>{" "}
                              <Form.Label
                                style={{ marginLeft: "5px" }}
                                column
                                lg={2}
                                id="smallerFontSize"
                              >
                                {" "}
                                WL{" "}
                              </Form.Label>
                              <Form.Check
                                type="radio"
                                name="countriesType"
                                value="bl"
                                onChange={(e) => {
                                  setCountriesType("bl");
                                  setUsersSaveDisabled(false);
                                }}
                                checked={countriesType == "bl" ? true : false}
                                style={{ marginLeft: "5px" }}
                              />{" "}
                              <Form.Label
                                style={{ marginLeft: "5px" }}
                                column
                                lg={2}
                                id="smallerFontSize"
                              >
                                {" "}
                                BL{" "}
                              </Form.Label>
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={2}>
                            Countries List
                          </Form.Label>
                          <Col lg={10}>
                            <Select
                              isMulti={true}
                              options={counties_list.map((x) => {
                                return { value: x.code, label: x.name };
                              })}
                              className="react-select react-select-container"
                              classNamePrefix="react-select"
                              onChange={(e) => {
                                setListCountries(e);
                                setUsersSaveDisabled(false);
                              }}
                              value={listCountries}
                            ></Select>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={3} id="smallerFontSize">
                            Countries WL/BL includes Proxy
                          </Form.Label>
                          <Col lg={9}>
                            <div className="toggle-switch">
                              <Form.Check
                                type="switch"
                                id="wlblProxyToggle"
                                onChange={(e) =>
                                  onChangeWLBLProxy(
                                    e.target.checked ? "on" : "off"
                                  )
                                }
                                checked={wlblProxy === true}
                              />
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={3} id="smallerFontSize">
                            Ignore User if Proxy exists
                          </Form.Label>
                          <Col lg={9}>
                            <div className="toggle-switch">
                              <Form.Check
                                type="switch"
                                id="ignoreUserProxyToggle"
                                onChange={(e) =>
                                  onChangeIgnoreUserProxy(
                                    e.target.checked ? "on" : "off"
                                  )
                                }
                                checked={ignoreUserProxy === true}
                              />
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={3} id="smallerFontSize">
                            Browsers WL/BL
                          </Form.Label>
                          <Col lg={8}>
                            <div className="checkboxes">
                            <Form.Check
                                type="radio"
                                id="browsers_off"
                                name="browsersType"
                                value="off"
                                onChange={(e) => {
                                setBrowsersType("off");
                                setUsersSaveDisabled(false); 
                                }}
                                checked={browsersType == "off" ? true : false}
                              />
                              {" "}
                              <Form.Label
                                style={{ marginLeft: "5px" }}
                                column
                                lg={4}
                                id="smallerFontSize"
                              >
                                {" "}
                                Disabled{" "}
                              </Form.Label>
                              <Form.Check
                                type="radio"
                                name="browsersType"
                                value="wl"
                                onChange={(e) => {
                                  setBrowsersType("wl");
                                  setUsersSaveDisabled(false);
                                }}
                                checked={browsersType == "wl" ? true : false}
                              ></Form.Check>{" "}
                              <Form.Label
                                style={{ marginLeft: "5px" }}
                                column
                                lg={2}
                                id="smallerFontSize"
                              >
                                {" "}
                                WL{" "}
                              </Form.Label>
                              <Form.Check
                                type="radio"
                                name="browsersType"
                                value="bl"
                                onChange={(e) => {
                                  setBrowsersType("bl");
                                  setUsersSaveDisabled(false);
                                }}
                                checked={browsersType == "bl" ? true : false}
                                style={{ marginLeft: "5px" }}
                              />{" "}
                              <Form.Label
                                style={{ marginLeft: "5px" }}
                                column
                                lg={2}
                                id="smallerFontSize"
                              >
                                {" "}
                                BL{" "}
                              </Form.Label>
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
          {browsersType !== "off" && (
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={2}>
                            Browsers List
                          </Form.Label>
                          <Col lg={10}>
                            <Select
                              isMulti={true}
                              options={browsers_list.map((x) => {
                                return { value: x.name, label: x.name };
                              })}
                              className="react-select react-select-container"
                              classNamePrefix="react-select"
                              onChange={(e) => {
                                setListBrowsers(e);
                                setUsersSaveDisabled(false);
                              }}
                              value={listBrowsers}
                            ></Select>
                          </Col>
                        </Form.Group>
                      </Row>
                      )}
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={3} id="smallerFontSize">
                            OS WL/BL
                          </Form.Label>
                          <Col lg={9}>
                            <div className="checkboxes">
                              <Form.Check
                                type="radio"
                                name="ossType"
                                value="wl"
                                onChange={(e) => {
                                  setOSsType("wl");
                                  setUsersSaveDisabled(false);
                                }}
                                checked={ossType == "wl" ? true : false}
                              ></Form.Check>{" "}
                              <Form.Label
                                style={{ marginLeft: "5px" }}
                                column
                                lg={2}
                                id="smallerFontSize"
                              >
                                {" "}
                                WL{" "}
                              </Form.Label>
                              <Form.Check
                                type="radio"
                                name="ossType"
                                value="bl"
                                onChange={(e) => {
                                  setOSsType("bl");
                                  setUsersSaveDisabled(false);
                                }}
                                checked={ossType == "bl" ? true : false}
                                style={{ marginLeft: "5px" }}
                              />{" "}
                              <Form.Label
                                style={{ marginLeft: "5px" }}
                                column
                                lg={2}
                                id="smallerFontSize"
                              >
                                {" "}
                                BL{" "}
                              </Form.Label>
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={2}>
                            OS List
                          </Form.Label>
                          <Col lg={10}>
                            <Select
                              isMulti={true}
                              options={os_list.map((x) => {
                                return { value: x.code, label: x.name };
                              })}
                              className="react-select react-select-container"
                              classNamePrefix="react-select"
                              onChange={(e) => {
                                setListOs(e);
                                setUsersSaveDisabled(false);
                              }}
                              value={listOs}
                            ></Select>
                          </Col>
                        </Form.Group>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
                <Col lg={6} className="mb-3">
                  <Card className="h-100">
                    <Card.Body>
                      <h4
                        style={{
                          fontSize: "15px",
                          margin: "0 0 7px",
                          fontWeight: "600",
                          textTransform: "uppercase",
                        }}
                      >
                        CREATIVE UPLOAD
                      </h4>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            Line Items
                          </Form.Label>
                          <Col lg={9}>
                            <Form.Control
                              type="text"
                              id="simpleinput"
                              value={cc_lineItems}
                              onChange={(e) => {
                                setCc_lineItems(e.target.value);
                                setUsersSaveDisabled(false);
                              }}
                              className="fsz-875rem"
                              // isInvalid={
                              //   ctargetingUserIDs ? false : isValidateCTargeting
                              // }
                            />
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            S3 Root Folder
                          </Form.Label>
                          <Col lg={8}>
                            <Form.Control
                              type="text"
                              id="simpleinput"
                              className="fsz-875rem"
                              value={ccreative_folder}
                            />
                          </Col>
                          <Col lg={2}>
                            <Button
                              variant="primary"
                              onClick={() => handleCheckFolderContent()}
                            >
                              Browse
                            </Button>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={2}>
                            DSP
                          </Form.Label>
                          <Col lg={10}>
                            <Select
                              // options={dspOptions}
                              // className="react-select react-select-container"
                              // classNamePrefix="react-select"
                              // defaultValue={dspOptions[0]}

                              options={dspOptions.map((x) => {
                                return { value: x.value, label: x.label };
                              })}
                              className="react-select react-select-container"
                              classNamePrefix="react-select"
                              onChange={(e) => {
                                setCc_dsp(e);
                                setUsersSaveDisabled(false);
                              }}
                              value={cc_dsp}
                              defaultValue={dspOptions[0]}
                            ></Select>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={2}>
                            Advertiser
                          </Form.Label>
                          <Col lg={10}>
                            <Select
                              options={advertiserOptions.map((x) => {
                                return { value: x.value, label: x.label };
                              })}
                              className="react-select react-select-container"
                              classNamePrefix="react-select"
                              onChange={(e) => {
                                setCc_adv(e);
                                setUsersSaveDisabled(false);
                              }}
                              value={cc_adv}
                              defaultValue={advertiserOptions[0]}
                            ></Select>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={2}>
                            OS
                          </Form.Label>
                          <Col lg={10}>
                            <Select
                              options={OsOptions.map((x) => {
                                return { value: x.value, label: x.label };
                              })}
                              className="react-select react-select-container"
                              classNamePrefix="react-select"
                              onChange={(e) => {
                                setCc_os(e);
                                setUsersSaveDisabled(false);
                              }}
                              value={cc_os}
                              defaultValue={OsOptions[2]}
                            ></Select>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={2}>
                            NOAS
                          </Form.Label>
                          <Col lg={10}>
                            <Select
                              options={yesnoOptions.map((x) => {
                                return { value: x.value, label: x.label };
                              })}
                              className="react-select react-select-container"
                              classNamePrefix="react-select"
                              onChange={(e) => {
                                setCc_noas(e);
                                setUsersSaveDisabled(false);
                              }}
                              value={cc_noas}
                              defaultValue={yesnoOptions[0]}
                            ></Select>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={2}>
                            Cookie
                          </Form.Label>
                          <Col lg={10}>
                            <Select
                              options={yesnoOptions.map((x) => {
                                return { value: x.value, label: x.label };
                              })}
                              className="react-select react-select-container"
                              classNamePrefix="react-select"
                              onChange={(e) => {
                                setCc_cookie(e);
                                setUsersSaveDisabled(false);
                              }}
                              value={cc_cookie}
                              defaultValue={yesnoOptions[0]}
                            ></Select>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={2}>
                            UserAgent
                          </Form.Label>
                          <Col lg={10}>
                            <Select
                              options={yesnoOptions.map((x) => {
                                return { value: x.value, label: x.label };
                              })}
                              className="react-select react-select-container"
                              classNamePrefix="react-select"
                              onChange={(e) => {
                                setCc_ua(e);
                                setUsersSaveDisabled(false);
                              }}
                              value={cc_ua}
                              defaultValue={yesnoOptions[1]}
                            ></Select>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={2}>
                            Timer
                          </Form.Label>
                          <Col lg={10}>
                            <Select
                              options={yesnoOptions.map((x) => {
                                return { value: x.value, label: x.label };
                              })}
                              className="react-select react-select-container"
                              classNamePrefix="react-select"
                              onChange={(e) => {
                                setCc_timer(e);
                                setUsersSaveDisabled(false);
                              }}
                              value={cc_timer}
                              defaultValue={yesnoOptions[1]}
                            ></Select>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={2}>
                            Infinite FIFO
                          </Form.Label>
                          <Col lg={10}>
                            <Select
                              options={yesnoOptions.map((x) => {
                                return { value: x.value, label: x.label };
                              })}
                              className="react-select react-select-container"
                              classNamePrefix="react-select"
                              onChange={(e) => {
                                setCc_infinite_fifo(e);
                                setUsersSaveDisabled(false);
                              }}
                              value={cc_infinite_fifo}
                              defaultValue={yesnoOptions[1]}
                            ></Select>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label column lg={2}>
                            Detect IPv6
                          </Form.Label>
                          <Col lg={10}>
                            <Select
                              options={yesnoOptions.map((x) => {
                                return { value: x.value, label: x.label };
                              })}
                              className="react-select react-select-container"
                              classNamePrefix="react-select"
                              onChange={(e) => {
                                setCc_ipV6(e);
                                setUsersSaveDisabled(false);
                              }}
                              value={cc_ipV6}
                              defaultValue={yesnoOptions[1]}
                            ></Select>
                          </Col>
                        </Form.Group>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
                <Modal
                  className="modal-xl"
                  show={showS3Browser === true}
                  onHide={() => {
                    setShowS3Browser(false);
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      margin: "24px",
                    }}
                  >
                    <h3
                      style={{
                        color: "#343a40",
                        textAlign: "left",
                        fontSize: "1.05rem",
                        fontWeight: "600",
                      }}
                    >
                      Folder Name:<p>{cur_folder} </p>
                    </h3>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                      }}
                    >
                      <ButtonGroup
                        className=" fsz-875rem"
                        style={{
                          width: "max-content",
                          margin: "0",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Button
                          style={{ margin: "0" }}
                          variant="light"
                          onClick={() => {
                            handleFolderBack(cur_folder);
                          }}
                        >
                          <Back /> <span>Back</span>
                        </Button>
                      </ButtonGroup>

                      <Button
                        className="fsz-875rem"
                        variant="light"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          width: "max-content",
                          margin: "0 0 0 8px",
                        }}
                        onClick={() => {
                          handleCheckFolderContent();
                        }}
                      >
                        <House className="me-2 fsz-875rem" />
                        <span>Home</span>
                      </Button>
                    </div>
                  </div>

                  <h6
                    style={{
                      fontSize: "18px",
                      fontWeight: "600",
                      margin: "24px",
                    }}
                  >
                    Sub-Folders
                  </h6>
                  <Row>
                    <Col lg={2}>
                      <ButtonGroup style={{ marginLeft: "20px" }}>
                        <Button
                          onClick={() => {
                            handleChooseThisFolder();
                          }}
                          variant="primary"
                        >
                          Choose This Folder
                        </Button>
                      </ButtonGroup>
                    </Col>
                    <Col lg={4}>
                      <Button
                        onClick={() => {
                          setCreateSubFolderPopup(true);
                        }}
                        variant="info"
                      >
                        + Create New Sub-Folder
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    {(adminState.s3Folders || []).map((f: any, i: number) => {
                      let folderDetails = f.name.split("/");

                      return (
                        <Col key={i} xxl={3} lg={6}>
                          <Card
                            className="shadow-none border"
                            style={{ margin: "10px" }}
                          >
                            <div style={{ padding: "12px" }}>
                              <Row className="align-items-center">
                                <Col
                                  className="col-auto"
                                  style={{ marginLeft: "15px" }}
                                >
                                  <div className="avatar-sm">
                                    <span
                                      className={`avatar-title rounded fs-24 bg-soft-info text-info`}
                                      style={{ padding: "8px" }}
                                    >
                                      <Folder size={24} color="#35c2e3" />
                                    </span>
                                  </div>
                                </Col>
                                <Col className="ps-1">
                                  <Link
                                    to="#"
                                    style={{ textDecoration: "none" }}
                                    className="text-muted fw-bold fs-15"
                                  >
                                    <span
                                      onClick={() => {
                                        handleFolderClick(f.name);
                                      }}
                                    >
                                      {folderDetails[folderDetails.length - 2]}
                                      <br />
                                      <span
                                        style={{
                                          fontWeight: 400,
                                          opacity: "0.7",
                                        }}
                                      >
                                        Last Modified:{" "}
                                        {moment(f.lastMod).format("DD/MM/YYYY")}
                                      </span>
                                    </span>
                                  </Link>
                                </Col>
                              </Row>
                            </div>
                          </Card>
                        </Col>
                      );
                    })}
                  </Row>
                </Modal>
                {createSubFolderPopup && (
                  <>
                    <Modal
                      show={createSubFolderPopup}
                      onHide={() => {
                        setCreateSubFolderPopup(false);
                        setCheckFolder(false);
                      }}
                    >
                      <Modal.Header
                        style={{ borderBottom: "0" }}
                        onHide={() => {
                          setCreateSubFolderPopup(false);
                          setCheckFolder(false);
                        }}
                        closeButton
                      >
                        <Modal.Title
                          as="h4"
                          style={{ fontSize: ".9375rem", fontWeight: "700" }}
                        >
                          Create New Sub-Folder
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Form.Label
                            column
                            lg={4}
                            htmlFor="folder_name"
                            id="smallerFontSize"
                          >
                            Folder Name
                            {createSubFolderForm.errors.folder_name && (
                              <span
                                style={{
                                  color: "#dc3545",
                                  fontFamily: "Silka",
                                  fontSize: 12,
                                }}
                              >
                                {createSubFolderForm.errors.folder_name}
                              </span>
                            )}
                          </Form.Label>
                          <Col lg={8}>
                            <FormControl
                              name="folder_name"
                              onChange={(e) => {
                                setCheckFolder(false);
                                setFolderName(e.target.value);
                                createSubFolderForm.handleChange(e);
                              }}
                              onBlur={createSubFolderForm.handleBlur}
                            ></FormControl>
                          </Col>
                        </Form.Group>
                        {!validFolder && checkFolder && (
                          <p
                            style={{
                              fontWeight: 700,
                              fontSize: "0.875rem !important",
                              color: "#ff0000",
                            }}
                          >
                            Folder name already exists. Please use a different
                            name.
                          </p>
                        )}
                      </Modal.Body>
                      <Modal.Footer style={{ borderTop: "0" }}>
                        <Button
                          variant="light"
                          onClick={() => {
                            setCheckFolder(false);
                            setCreateSubFolderPopup(false);
                          }}
                        >
                          Close
                        </Button>
                        <Button
                          variant="primary"
                          onClick={() => {
                            if (
                              JSON.stringify(createSubFolderForm.errors) ===
                                "{}" &&
                              JSON.stringify(createSubFolderForm.touched) !==
                                "{}"
                            ) {
                              handleCreateSubFolder();
                              // createSubFolderForm.handleSubmit();
                              // setCreateSubFolderPopup(false);
                            }
                          }}
                        >
                          Save changes
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </>
                )}
              </Row>
              <Row>
                <Col lg={6} className="mb-3">
                  <Card className="h-100">
                    <Card.Body>
                      <Row>
                        <h4
                          style={{
                            fontSize: "15px",
                            margin: "0 0 7px",
                            fontWeight: "600",
                            textTransform: "uppercase",
                          }}
                        >
                          PROD IP FILTERING - LINE ITEMS
                        </h4>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            BW With User ID
                          </Form.Label>
                          <Col lg={9}>
                            <Form.Control
                              type="text"
                              id="simpleinput"
                              value={cLineItem}
                              onChange={(e) => {
                                setCLineItem(e.target.value);
                                setUsersSaveDisabled(false)
                              }}
                              className={`fsz-875rem ${invalidFields.includes("cLineItem") ? "is-invalid" : ""}`}
                            />
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            BW Without User ID
                          </Form.Label>
                          <Col lg={9}>
                            <Form.Control
                              type="text"
                              id="simpleinput"
                              value={cLineItemWithoutUserID}
                              onChange={(e) => {
                                setCLineItemWithoutUserID(e.target.value);
                                setUsersSaveDisabled(false)
                              }}
                              className={`fsz-875rem ${invalidFields.includes("cLineItemWithoutUserID") ? "is-invalid" : ""}`}
                            />
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            MyDSP With User ID
                          </Form.Label>
                          <Col lg={9}>
                            <Form.Control
                              type="text"
                              id="simpleinput"
                              value={cLineItemMyDSP}
                              onChange={(e) => {
                                setCLineItemMyDSP(e.target.value);
                                setUsersSaveDisabled(false)
                              }}
                              className={`fsz-875rem ${invalidFields.includes("cLineItemMyDSP") ? "is-invalid" : ""}`}
                            />
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            MyDSP Without User ID
                          </Form.Label>
                          <Col lg={9}>
                            <Form.Control
                              type="text"
                              id="simpleinput"
                              value={cLineItemWithoutUserIDMyDSP}
                              onChange={(e) => {
                                setCLineItemWithoutUserIDMyDSP(e.target.value);
                                setUsersSaveDisabled(false)
                              }}
                              className={`fsz-875rem ${invalidFields.includes("cLineItemWithoutUserIDMyDSP") ? "is-invalid" : ""}`}
                            />
                          </Col>
                        </Form.Group>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
                <Col lg={6} className="mb-3">
                  <Card className="h-100">
                    <Card.Body>
                      <h4
                        style={{
                          fontSize: "15px",
                          margin: "0 0 7px",
                          fontWeight: "600",
                          textTransform: "uppercase",
                        }}
                      >
                        DEMO IP FILTERING - LINE ITEMS
                      </h4>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            BW With User ID
                          </Form.Label>
                          <Col lg={9}>
                            <Form.Control
                              type="text"
                              id="simpleinput"
                              value={cLineItemDemo}
                              onChange={(e) => {
                                setCLineItemDemo(e.target.value);
                                if (
                                  e.target.value !== "" &&
                                  !cLineItemDemoWithoutUserID
                                ) {
                                  setUsersSaveDisabled(false);
                                } else {
                                  if (cLineItemDemoWithoutUserID) {
                                    setUsersSaveDisabled(false);
                                  } else {
                                    setUsersSaveDisabled(true);
                                  }
                                }
                              }}
                              className="fsz-875rem"
                              isInvalid={
                                cLineItemDemo || cLineItemDemoWithoutUserID
                                  ? false
                                  : isValidateDemoClineItem
                              }
                            />
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            BW Without User ID
                          </Form.Label>
                          <Col lg={9}>
                            <Form.Control
                              type="text"
                              id="simpleinput"
                              value={cLineItemDemoWithoutUserID}
                              onChange={(e) => {
                                setCLineItemDemoWithoutUserID(e.target.value);
                                if (e.target.value !== "" && !cLineItemDemo) {
                                  setUsersSaveDisabled(false);
                                } else {
                                  if (cLineItemDemo) {
                                    setUsersSaveDisabled(false);
                                  } else {
                                    setUsersSaveDisabled(true);
                                  }
                                }
                              }}
                              className="fsz-875rem"
                              isInvalid={
                                cLineItemDemo || cLineItemDemoWithoutUserID
                                  ? false
                                  : isValidateDemoClineItem
                              }
                            />
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            MyDSP With User ID
                          </Form.Label>
                          <Col lg={9}>
                            <Form.Control
                              type="text"
                              id="simpleinput"
                              value={cLineItemDemoMyDSP}
                              onChange={(e) => {
                                setCLineItemDemoMyDSP(e.target.value);
                                if (
                                  e.target.value !== "" &&
                                  !cLineItemDemoWithoutUserIDMyDSP
                                ) {
                                  setUsersSaveDisabled(false);
                                } else {
                                  if (cLineItemDemoWithoutUserIDMyDSP) {
                                    setUsersSaveDisabled(false);
                                  } else {
                                    setUsersSaveDisabled(true);
                                  }
                                }
                              }}
                              className="fsz-875rem"
                              // isInvalid={
                              //   cLineItemDemo || cLineItemDemoWithoutUserID
                              //     ? false
                              //     : isValidateDemoClineItem
                              // }
                            />
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            MyDSP Without User ID
                          </Form.Label>
                          <Col lg={9}>
                            <Form.Control
                              type="text"
                              id="simpleinput"
                              value={cLineItemDemoWithoutUserIDMyDSP}
                              onChange={(e) => {
                                setCLineItemDemoWithoutUserIDMyDSP(
                                  e.target.value
                                );
                                if (
                                  e.target.value !== "" &&
                                  !cLineItemDemoMyDSP
                                ) {
                                  setUsersSaveDisabled(false);
                                } else {
                                  if (cLineItemDemoMyDSP) {
                                    setUsersSaveDisabled(false);
                                  } else {
                                    setUsersSaveDisabled(true);
                                  }
                                }
                              }}
                              className="fsz-875rem"
                              // isInvalid={
                              //   cLineItemDemo || cLineItemDemoWithoutUserID
                              //     ? false
                              //     : isValidateDemoClineItem
                              // }
                            />
                          </Col>
                        </Form.Group>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col lg={6} className="mb-3">
                  <Card className="h-100">
                    <Card.Body>
                      <h4
                        style={{
                          fontSize: "15px",
                          margin: "0 0 7px",
                          fontWeight: "600",
                          textTransform: "uppercase",
                        }}
                      >
                        C-LOGGER
                      </h4>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            User Key
                          </Form.Label>
                          <Col lg={9}>
                            <Form.Control
                              type="text"
                              id="simpleinput"
                              value={cLogger}
                              onChange={(e) => {
                                setCLogger(e.target.value);
                                setUsersSaveDisabled(false);
                              }}
                              className={`fsz-875rem ${invalidFields.includes("cLogger") ? "is-invalid" : ""}`}
                              isInvalid={cLogger ? false : isValidateCLogger}
                            />
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            Auto Clear Events
                          </Form.Label>
                          <Col lg={9}>
                            <Select
                              isMulti={false}
                              options={auto_clear_events_list.map((x) => {
                                return { value: x.value, label: x.label };
                              })}
                              className="react-select react-select-container"
                              classNamePrefix="react-select"
                              onChange={(e) => {
                                setCloggerClearEvents(e);
                                setUsersSaveDisabled(false);
                              }}
                              value={cloggerClearEvents}
                              maxMenuHeight={100}
                            ></Select>
                            {isValidateCJSCIds && cJscId.length === 0 && (
                              <span
                                style={{
                                  color: "#dc3545",
                                  fontFamily: "Silka",
                                  fontSize: 12,
                                }}
                              >
                                Please select
                              </span>
                            )}
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Form.Label
                            column
                            lg={3}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            Show Filter Errors
                          </Form.Label>
                          <Col lg={9}>
                            <div className="toggle-switch">
                              <Form.Check
                                type="switch"
                                id="showFilterErrorsToggle"
                                onChange={(e) =>
                                  onChangeShowFilterErrors(
                                    e.target.checked ? "on" : "off"
                                  )
                                }
                                checked={showFilterErrors}
                              />
                            </div>
                          </Col>
                        </Form.Group>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
                <Col lg={6} className="mb-3">
                  <Card className="h-100">
                    <Card.Body>
                      <h4
                        style={{
                          fontSize: "15px",
                          margin: "0 0 7px",
                          fontWeight: "600",
                          textTransform: "uppercase",
                        }}
                      >
                        UPLOAD AUDIENCE
                      </h4>
                      {/* <Form.Group
                        as={Row}
                        className="mb-3"
                        style={{ display: "flex", alignItems: "center" }}
                      > */}
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label
                            column
                            lg={2}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            Auto Filter DSP
                          </Form.Label>
                          <Col
                            lg={10}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              flexWrap: "wrap",
                            }}
                          >
                            <Col xs="auto" style={{ display: "flex" }}>
                              <Form.Check
                                id="checkbox-dsp_mydsp"
                                type="checkbox"
                                name="dsp_mydsp"
                                checked={audienceFormik.values.dsp_mydsp}
                                onChange={audienceFormik.handleChange}
                                onBlur={audienceFormik.handleBlur}
                              />
                              <Form.Label
                                style={{ margin: "0px 15px 0px 5px" }}
                                id="smallerFontSize"
                                htmlFor="checkbox-dsp_mydsp"
                              >
                                MyDSP
                              </Form.Label>
                            </Col>
                            <Col xs="auto" style={{ display: "flex" }}>
                              <Form.Check
                                id="checkbox-dsp_bw"
                                type="checkbox"
                                name="dsp_bw"
                                checked={audienceFormik.values.dsp_bw}
                                onChange={audienceFormik.handleChange}
                                onBlur={audienceFormik.handleBlur}
                              />
                              <Form.Label
                                style={{ margin: "0px 15px 0px 5px" }}
                                id="smallerFontSize"
                                htmlFor="checkbox-dsp_bw"
                              >
                                Beeswax
                              </Form.Label>
                            </Col>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label
                            column
                            lg={2}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            Users Type
                          </Form.Label>
                          <Col
                            lg={10}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              flexWrap: "wrap",
                            }}
                          >
                            <Col xs="auto" style={{ display: "flex" }}>
                              <Form.Check
                                id="checkbox-idfa"
                                type="checkbox"
                                name="audience_idfa"
                                checked={audienceFormik.values.audience_idfa}
                                onChange={audienceFormik.handleChange}
                                onBlur={audienceFormik.handleBlur}
                              />
                              <Form.Label
                                style={{ margin: "0px 15px 0px 5px" }}
                                id="smallerFontSize"
                                htmlFor="checkbox-idfa"
                              >
                                IDFA
                              </Form.Label>
                            </Col>
                            <Col xs="auto" style={{ display: "flex" }}>
                              <Form.Check
                                id="checkbox-ad_id"
                                type="checkbox"
                                name="audience_ad_id"
                                checked={audienceFormik.values.audience_ad_id}
                                onChange={audienceFormik.handleChange}
                                onBlur={audienceFormik.handleBlur}
                              />
                              <Form.Label
                                style={{ margin: "0px 15px 0px 5px" }}
                                id="smallerFontSize"
                              >
                                AD_ID
                              </Form.Label>
                            </Col>
                            <Col xs="auto" style={{ display: "flex" }}>
                              <Form.Check
                                id="checkbox-ip_address"
                                type="checkbox"
                                name="audience_ip_address"
                                checked={
                                  audienceFormik.values.audience_ip_address
                                }
                                onChange={audienceFormik.handleChange}
                                onBlur={audienceFormik.handleBlur}
                              />
                              <Form.Label
                                style={{ margin: "0px 15px 0px 5px" }}
                                id="smallerFontSize"
                              >
                                IP Address
                              </Form.Label>
                            </Col>
                            <Col xs="auto" style={{ display: "flex" }}>
                              <Form.Check
                                id="checkbox-web_id"
                                type="checkbox"
                                name="audience_web_id"
                                checked={audienceFormik.values.audience_web_id}
                                onChange={audienceFormik.handleChange}
                                onBlur={audienceFormik.handleBlur}
                              />
                              <Form.Label
                                style={{ margin: "0px 15px 0px 5px" }}
                                id="smallerFontSize"
                              >
                                WEB_ID
                              </Form.Label>
                            </Col>
                          </Col>
                        </Form.Group>
                      </Row>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Form.Label
                          column
                          lg={3}
                          htmlFor="simpleinput"
                          id="smallerFontSize"
                        >
                          BW User IDs Value
                        </Form.Label>
                        <Col lg={9}>
                          <Form.Control
                            type="text"
                            id="simpleinput"
                            value={ctargetingUserIDs}
                            onChange={(e) => {
                              const processedSegments = handleChangeSegments(e);
                              setCtargetingUserIDs(processedSegments);
                              setUsersSaveDisabled(false);
                            }}
                            className={`fsz-875rem ${invalidFields.includes("ctargetingUserIDs") ? "is-invalid" : ""}`}
                            isInvalid={
                              ctargetingUserIDs ? false : isValidateCTargeting
                            }
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Form.Label
                          column
                          lg={3}
                          htmlFor="simpleinput"
                          id="smallerFontSize"
                        >
                          BW WiFi IP Addresses Value
                        </Form.Label>
                        <Col lg={9}>
                          <Form.Control
                            type="text"
                            id="simpleinput"
                            value={cTargetingIpAddressValue}
                            onChange={(e) => {
                              const processedSegments = handleChangeSegments(e);
                              setCTargetingIpAddressValue(processedSegments);
                              setUsersSaveDisabled(false);
                            }}
                            className="fsz-875rem"
                            isInvalid={
                              cTargetingIpAddressValue
                                ? false
                                : isValidateCTargeting
                            }
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Form.Label
                          column
                          lg={3}
                          htmlFor="simpleinput"
                          id="smallerFontSize"
                        >
                          BW Mobile Data IP Addresses Value
                        </Form.Label>
                        <Col lg={9}>
                          <Form.Control
                            type="text"
                            id="simpleinput"
                            value={cTargetingMobileIpAddressValue}
                            onChange={(e) => {
                              const processedSegments = handleChangeSegments(e);
                              setCTargetingMobileIpAddressValue(
                                processedSegments
                              );
                              setUsersSaveDisabled(false);
                            }}
                            className="fsz-875rem"
                            isInvalid={
                              cTargetingMobileIpAddressValue
                                ? false
                                : isValidateCTargeting
                            }
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Form.Label
                          column
                          lg={3}
                          htmlFor="simpleinput"
                          id="smallerFontSize"
                        >
                          BW IP Without User ID
                        </Form.Label>
                        <Col lg={9}>
                          <Form.Control
                            type="text"
                            id="simpleinput"
                            value={cTargetingIpNoId}
                            onChange={(e) => {
                              const processedSegments = handleChangeSegments(e);
                              setCTargetingIpNoId(processedSegments);
                              setUsersSaveDisabled(false);
                            }}
                            className="fsz-875rem"
                            isInvalid={
                              cTargetingIpNoId ? false : isValidateCTargeting
                            }
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Form.Label
                          column
                          lg={3}
                          htmlFor="simpleinput"
                          id="smallerFontSize"
                        >
                          BW Multi Ad URL With UID
                        </Form.Label>
                        <Col lg={9}>
                          <Form.Control
                            type="text"
                            id="simpleinput"
                            value={cTargetingMultiUid}
                            onChange={(e) => {
                              const processedSegments = handleChangeSegments(e);
                              setCtargetingMultiUid(processedSegments);
                              setUsersSaveDisabled(false);
                            }}
                            className="fsz-875rem"
                            isInvalid={
                              cTargetingMultiUid ? false : isValidateCTargeting
                            }
                            disabled={!audienceFormik.values.dsp_bw}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Form.Label
                          column
                          lg={3}
                          htmlFor="simpleinput"
                          id="smallerFontSize"
                        >
                          BW Multi Ad URL NO ID
                        </Form.Label>
                        <Col lg={9}>
                          <Form.Control
                            type="text"
                            id="simpleinput"
                            value={cTargetingMultiNoId}
                            onChange={(e) => {
                              const processedSegments = handleChangeSegments(e);
                              setCtargetingMultiNoId(processedSegments);
                              setUsersSaveDisabled(false);
                            }}
                            className="fsz-875rem"
                            isInvalid={
                              cTargetingMultiNoId ? false : isValidateCTargeting
                            }
                            disabled={!audienceFormik.values.dsp_bw}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Form.Label
                          column
                          lg={3}
                          htmlFor="simpleinput"
                          id="smallerFontSize"
                        >
                          Creative Upload Segments
                        </Form.Label>
                        <Col lg={9}>
                          <Form.Control
                            type="text"
                            id="simpleinput"
                            value={cTargetingCCreativeValue}
                            onChange={(e) => {
                              //setCTargetingCCreativeValue(e.target.value.split(','));
                              const processedSegments =
                                handleChangeCCreativeSegments(e);
                              setCTargetingCCreativeValue(processedSegments);
                              setUsersSaveDisabled(false);
                            }}
                            disabled={isCcreativeEnabled()}
                            className="fsz-875rem"
                            isInvalid={
                              cTargetingCCreativeValue
                                ? false
                                : isValidateCTargeting
                            }
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Form.Label
                          column
                          lg={3}
                          htmlFor="simpleinput"
                          id="smallerFontSize"
                        >
                          MyDSP: IP addresses Campaign
                        </Form.Label>
                        <Col lg={9}>
                          <Form.Control
                            type="text"
                            id="simpleinput"
                            value={cTargetingIPMyDSP}
                            onChange={(e) => {
                              setCTargetingIPMyDSP(e.target.value);
                              setUsersSaveDisabled(false);
                            }}
                            className="fsz-875rem"
                            disabled={!audienceFormik.values.dsp_mydsp}
                            // isInvalid={
                            //   ctargetingUserIDs ? false : isValidateCTargeting
                            // }
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Form.Label
                          column
                          lg={3}
                          htmlFor="simpleinput"
                          id="smallerFontSize"
                        >
                          MyDSP: Web ID List
                        </Form.Label>
                        <Col lg={9}>
                          <Form.Control
                            type="text"
                            id="simpleinput"
                            value={cTargetingWebMyDSP}
                            onChange={(e) => {
                              setCTargetingWebMyDSP(e.target.value);
                              setUsersSaveDisabled(false);
                            }}
                            className="fsz-875rem"
                            disabled={!audienceFormik.values.dsp_mydsp}
                            // isInvalid={
                            //   cTargetingMobileIpAddressValue
                            //     ? false
                            //     : isValidateCTargeting
                            // }
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Form.Label
                          column
                          lg={3}
                          htmlFor="simpleinput"
                          id="smallerFontSize"
                        >
                          MyDSP: IDFA List
                        </Form.Label>
                        <Col lg={9}>
                          <Form.Control
                            type="text"
                            id="simpleinput"
                            value={cTargetingIDFA}
                            onChange={(e) => {
                              setCTargetingIDFA(e.target.value);
                              setUsersSaveDisabled(false);
                            }}
                            className="fsz-875rem"
                            disabled={!audienceFormik.values.dsp_mydsp}
                            // isInvalid={
                            //   cTargetingIpNoId
                            //     ? false
                            //     : isValidateCTargeting
                            // }
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Form.Label
                          column
                          lg={3}
                          htmlFor="simpleinput"
                          id="smallerFontSize"
                        >
                          MyDSP: GAID List
                        </Form.Label>
                        <Col lg={9}>
                          <Form.Control
                            type="text"
                            id="simpleinput"
                            value={cTargetingGAID}
                            onChange={(e) => {
                              setCTargetingGAID(e.target.value);
                              setUsersSaveDisabled(false);
                            }}
                            className="fsz-875rem"
                            disabled={!audienceFormik.values.dsp_mydsp}
                            // isInvalid={
                            //   cTargetingIpNoId
                            //     ? false
                            //     : isValidateCTargeting
                            // }
                          />
                        </Col>
                      </Form.Group>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col lg={6} className="mb-3">
                  <Card className="h-100">
                    <Card.Body>
                      <h4
                        style={{
                          fontSize: "15px",
                          margin: "0 0 7px",
                          fontWeight: "600",
                          textTransform: "uppercase",
                        }}
                      >
                        Dashboard & Budget
                      </h4>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Form.Label
                          column
                          lg={3}
                          htmlFor="simpleinput"
                          id="smallerFontSize"
                        >
                          Beeswax Line Items
                        </Form.Label>
                        <Col lg={9}>
                          <Form.Control
                            type="text"
                            id="simpleinput"
                            value={beeswaxCID}
                            onChange={(e) => {
                              setBeeswaxCID(e.target.value);
                              setUsersSaveDisabled(false);
                              // if (e.target.value) {
                              //   if (validateSpecialCharacter(e.target.value)) {
                              //     setUsersSaveDisabled(false);
                              //     setGluNameError(false);
                              //   } else {
                              //     setGluNameError(true);
                              //     setUsersSaveDisabled(true);
                              //   }
                              // } else {
                              //   setGluNameError(false);
                              // }
                            }}
                            className="fsz-875rem"
                            //isInvalid={gluName ? false : isValidateGluName}
                          />
                          {/* {gluNameError && (
                            <span
                              style={{
                                color: "#dc3545",
                                fontFamily: "Silka",
                                fontSize: 12,
                              }}
                            >
                              Please use only letters and numbers
                            </span>
                          )} */}
                        </Col>
                      </Form.Group>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Form.Label
                          column
                          lg={3}
                          htmlFor="simpleinput"
                          id="smallerFontSize"
                        >
                          Monthly Budget
                        </Form.Label>
                        <Col lg={9}>
                          <Form.Control
                            type="text"
                            id="simpleinput"
                            value={dashMonthlyBudget}
                            onChange={(e) => {
                              setDashMonthlyBudget(e.target.value);
                              setUsersSaveDisabled(false);
                            }}
                            className="fsz-875rem"
                          />
                        </Col>
                      </Form.Group>
                    </Card.Body>
                  </Card>
                </Col>
                <Col lg={6} className="mb-3">
                  <Card className="h-100">
                    <Card.Body>
                      <h4
                        style={{
                          fontSize: "15px",
                          margin: "0 0 7px",
                          fontWeight: "600",
                          textTransform: "uppercase",
                        }}
                      >
                        User Info
                      </h4>
                      <Row>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <Form.Label
                            column
                            lg={2}
                            htmlFor="simpleinput"
                            id="smallerFontSize"
                          >
                            Users Type
                          </Form.Label>
                          <Col
                            lg={10}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              flexWrap: "wrap",
                            }}
                          >
                            <Col xs="auto" style={{ display: "flex" }}>
                              <Form.Check
                                id="checkbox-eyield"
                                type="checkbox"
                                name="eyield"
                                checked={userInfoFormik.values.eyield}
                                onChange={userInfoFormik.handleChange}
                                onBlur={userInfoFormik.handleBlur}
                              />
                              <Form.Label
                                style={{ margin: "0px 15px 0px 5px" }}
                                id="smallerFontSize"
                                htmlFor="checkbox-eyield"
                              >
                                EYield
                              </Form.Label>
                            </Col>
                            <Col xs="auto" style={{ display: "flex" }}>
                              <Form.Check
                                id="checkbox-tyield"
                                type="checkbox"
                                name="tyield"
                                checked={userInfoFormik.values.tyield}
                                onChange={userInfoFormik.handleChange}
                                onBlur={userInfoFormik.handleBlur}
                              />
                              <Form.Label
                                style={{ margin: "0px 15px 0px 5px" }}
                                id="smallerFontSize"
                              >
                                TYield
                              </Form.Label>
                            </Col>
                            <Col xs="auto" style={{ display: "flex" }}>
                              <Form.Check
                                id="checkbox-sync_user"
                                type="checkbox"
                                name="sync_user"
                                checked={
                                  userInfoFormik.values.sync_user
                                }
                                onChange={userInfoFormik.handleChange}
                                onBlur={userInfoFormik.handleBlur}
                              />
                              <Form.Label
                                style={{ margin: "0px 15px 0px 5px" }}
                                id="smallerFontSize"
                              >
                                Sync_User
                              </Form.Label>
                            </Col>
                            <Col xs="auto" style={{ display: "flex" }}>
                              <Form.Check
                                id="checkbox-sync_domain"
                                type="checkbox"
                                name="sync_domain"
                                checked={
                                  userInfoFormik.values.sync_domain
                                }
                                onChange={userInfoFormik.handleChange}
                                onBlur={userInfoFormik.handleBlur}
                              />
                              <Form.Label
                                style={{ margin: "0px 15px 0px 5px" }}
                                id="smallerFontSize"
                              >
                                Sync_Domain
                              </Form.Label>
                            </Col>
                            <Col xs="auto" style={{ display: "flex" }}>
                              <Form.Check
                                id="checkbox-ah_user"
                                type="checkbox"
                                name="ah_user"
                                checked={userInfoFormik.values.ah_user}
                                onChange={userInfoFormik.handleChange}
                                onBlur={userInfoFormik.handleBlur}
                              />
                              <Form.Label
                                style={{ margin: "0px 15px 0px 5px" }}
                                id="smallerFontSize"
                              >
                                AH_User
                              </Form.Label>
                            </Col>
                          </Col>
                        </Form.Group>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col className="transperent">
                  <Card>
                    <Card.Body>
                      <Button
                        style={{ margin: "0" }}
                        disabled={
                          userIPRestrictionFromErr ||
                          userIPRestrictionToErr ||
                          usersSaveDisabled ||
                          (!cJscCallbackURL &&
                            ["url"].includes(cjscCallbackType))
                        }
                        variant="primary"
                        onClick={() => handleSaveUserRole()}
                      >
                        Save
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default AdminPage;
